(function () {
  var DUMP_MS = 150;
  var FPS_MIN = 250;
  var FPS_MAX = 340;
  var YARD_MIN = 10;
  var YARD_MAX = 150;
  var YARD_STEP = 5;
  var REF_YARD = 20;
  var GAP_YARD_LO = 20;
  var GAP_YARD_HI = 60;
  var GRAINS_MIN = 350;
  var GRAINS_MAX = 600;
  var DEFAULT_GRAINS = 450;
  var DEFAULT_BAL_OPTS = { grains: DEFAULT_GRAINS, tip: 'field', fletch: 3, diameter: '5mm' };
  var REF_PEEP_TO_SIGHT_IN = 31.25;
  var REF_PEEP_HEIGHT_IN = 4.5;
  var REF_GEOMETRY_RATIO = REF_PEEP_TO_SIGHT_IN / REF_PEEP_HEIGHT_IN;
  /** Converts ballistic pinGap to inches at reference peep geometry (~280 fps / 450 gr → ~0.80" 20–60). */
  var BALLISTIC_INCH_CALIB = 0.837;
  var PEEP_TO_SIGHT_MIN = 18;
  var PEEP_TO_SIGHT_MAX = 42;
  var PEEP_HEIGHT_MIN = 2.5;
  var PEEP_HEIGHT_MAX = 7;
  var DEFAULT_BG = '#ffffff';
  var DEFAULT_TEXT = '#222222';
  var DEFAULT_TICK = '#333333';
  var DEFAULT_TICK_FIVE = '#888888';
  var DEFAULT_TEXT_FIVE = '#888888';

  function num(el) {
    if (!el) return null;
    var raw = String(el.value).trim();
    if (raw === '') return null;
    var v = parseFloat(raw.replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  function clamp(n, min, max) {
    if (n == null || !isFinite(n)) return null;
    return Math.min(max, Math.max(min, n));
  }

  function fmt(n, digits) {
    if (n == null || !isFinite(n)) return '—';
    var p = Math.pow(10, digits);
    return (Math.round(n * p) / p).toFixed(digits);
  }

  function ballistics() {
    return window.TitleXBallistics;
  }

  function balOptsFromStyle(style) {
    if (!style) return DEFAULT_BAL_OPTS;
    return {
      grains: style.grains != null && style.grains > 0 ? style.grains : DEFAULT_GRAINS,
      tip: style.tip === 'fixed' ? 'fixed' : 'field',
      fletch: 3,
      diameter: style.diameter === 'tx23' ? 'tx23' : '5mm',
      densityAltFt:
        style.densityAltFt != null && style.densityAltFt > 0 ? style.densityAltFt : undefined,
    };
  }

  function sightPresets() {
    return window.TitleXSightTapeSights;
  }

  function inchesFromDisplay(value, units) {
    if (value == null || !isFinite(value)) return null;
    return units === 'mm' ? value / 25.4 : value;
  }

  function displayFromInches(inches, units) {
    if (inches == null || !isFinite(inches)) return '';
    return units === 'mm' ? String(Math.round(inches * 25.4 * 100) / 100) : String(Math.round(inches * 1000) / 1000);
  }

  function sightOptsFromStyle(style) {
    style = style || {};
    var units = style.sightUnits === 'mm' ? 'mm' : 'in';
    var pts = inchesFromDisplay(style.peepToSight, units);
    var ph = inchesFromDisplay(style.peepHeight, units);
    if (pts == null || pts <= 0) pts = REF_PEEP_TO_SIGHT_IN;
    if (ph == null || ph <= 0) ph = REF_PEEP_HEIGHT_IN;
    pts = clamp(pts, PEEP_TO_SIGHT_MIN, PEEP_TO_SIGHT_MAX);
    ph = clamp(ph, PEEP_HEIGHT_MIN, PEEP_HEIGHT_MAX);
    var preset = sightPresets();
    var sightId = style.sightId || (preset && preset.defaultId) || 'printed';
    var presetScale = preset && preset.presetScale ? preset.presetScale(sightId) : 1;
    return {
      peepToSight: pts,
      peepHeight: ph,
      sightId: sightId,
      sightUnits: units,
      geometryScale: (pts / ph / REF_GEOMETRY_RATIO) * BALLISTIC_INCH_CALIB * presetScale,
    };
  }

  function sightGeometryScale(sightOpts) {
    if (!sightOpts) return BALLISTIC_INCH_CALIB;
    return sightOpts.geometryScale != null && sightOpts.geometryScale > 0
      ? sightOpts.geometryScale
      : BALLISTIC_INCH_CALIB;
  }

  function balOptsWeightLabel(opts) {
    opts = opts || DEFAULT_BAL_OPTS;
    var grains = opts.grains != null && opts.grains > 0 ? Math.round(opts.grains) : DEFAULT_GRAINS;
    return grains + ' gr';
  }

  function balOptsLabel(opts) {
    return balOptsWeightLabel(opts);
  }

  function dropIn(fps, yards, balOpts) {
    var B = ballistics();
    if (!B || typeof B.dropInches !== 'function') return null;
    return B.dropInches(fps, yards, balOpts || DEFAULT_BAL_OPTS);
  }

  /** AA sight offset (in) from REF_YARD: drop(Y)/Y − drop(ref)/ref — not a per-yard increment. */
  function pinGap(fps, yards, balOpts) {
    var d = dropIn(fps, yards, balOpts);
    var d20 = dropIn(fps, REF_YARD, balOpts);
    if (d == null || d20 == null || yards <= 0) return null;
    return d / yards - d20 / REF_YARD;
  }

  function snapYard(n) {
    var c = clamp(n, YARD_MIN, YARD_MAX);
    if (c == null) return null;
    return Math.round(c / YARD_STEP) * YARD_STEP;
  }

  function yardMarks(startYd, endYd) {
    var out = [];
    for (var y = startYd; y <= endYd; y += YARD_STEP) out.push(y);
    return out;
  }

  function buildTape(fps, endYd, startYd, balOpts, sightOpts) {
    balOpts = balOpts || DEFAULT_BAL_OPTS;
    var geom = sightGeometryScale(sightOpts);
    var positions = {};
    var end = Math.max(endYd || GAP_YARD_HI, GAP_YARD_HI);
    var start = Math.min(startYd || REF_YARD, REF_YARD);
    for (var y = start; y <= end; y++) {
      if (y === REF_YARD) {
        positions[y] = 0;
      } else {
        var offset = pinGap(fps, y, balOpts);
        positions[y] = offset == null ? null : offset * geom;
      }
    }
    var gap2060 =
      positions[GAP_YARD_HI] != null && positions[GAP_YARD_LO] != null
        ? positions[GAP_YARD_HI] - positions[GAP_YARD_LO]
        : 0;
    return {
      fps: fps,
      positions: positions,
      gap2060: gap2060,
      geometryScale: geom,
    };
  }

  function tickYards(startYd, endYd, tickStep) {
    var step = tickStep || 5;
    var out = [];
    var seen = {};
    function add(y) {
      if (y < startYd || y > endYd || seen[y]) return;
      seen[y] = true;
      out.push(y);
    }
    add(startYd);
    for (var y = startYd; y <= endYd; y++) {
      if (y % step === 0) add(y);
    }
    add(endYd);
    out.sort(function (a, b) {
      return a - b;
    });
    return out;
  }

  function scaleForTape(tape, measuredGap) {
    if (measuredGap != null && measuredGap > 0 && tape.gap2060 > 0) {
      return measuredGap / tape.gap2060;
    }
    return 1;
  }

  /** Scale print/preview length from measured 20–60 gap only. */
  function resolveLengthScale(tape, opts) {
    opts = opts || {};
    var measuredGap = opts.measuredGap;
    if (measuredGap != null && measuredGap > 0 && tape.gap2060 > 0) {
      return { scale: measuredGap / tape.gap2060, method: 'gap' };
    }
    return { scale: 1, method: 'native' };
  }

  function signedPow(unit, power) {
    if (unit === 0 || !isFinite(unit)) return 0;
    return (unit < 0 ? -1 : 1) * Math.pow(Math.abs(unit), power);
  }

  function spanRatioAt(uStart, uEnd, power) {
    return signedPow(uEnd, power) - signedPow(uStart, power);
  }

  /** Power on the 20–60 gap so tick-to-tick equals the measured tape. 20 and 60 stay put. */
  function solveSpanPower(uStart, uEnd, target) {
    if (!(target > 0) || !isFinite(uStart) || !isFinite(uEnd)) return null;
    var linear = spanRatioAt(uStart, uEnd, 1);
    if (!(linear > 0)) return null;
    if (Math.abs(linear - target) < 0.0001) return 1;
    var lo = 0.05;
    var hi = 6;
    var spanLo = spanRatioAt(uStart, uEnd, lo);
    var spanHi = spanRatioAt(uStart, uEnd, hi);
    var increasing = spanHi > spanLo;
    if (increasing) {
      if (target < spanLo || target > spanHi) return null;
    } else if (target > spanLo || target < spanHi) {
      return null;
    }
    for (var i = 0; i < 48; i++) {
      var mid = (lo + hi) / 2;
      var span = spanRatioAt(uStart, uEnd, mid);
      if ((increasing && span < target) || (!increasing && span > target)) lo = mid;
      else hi = mid;
    }
    return (lo + hi) / 2;
  }

  function markShapeForTape(tape, measuredGap, measuredSpan, startYd, endYd) {
    if (
      !tape ||
      !(measuredGap > 0) ||
      !(measuredSpan > 0) ||
      !(tape.gap2060 > 0) ||
      tape.positions[startYd] == null ||
      tape.positions[endYd] == null
    ) {
      return null;
    }
    var uStart = tape.positions[startYd] / tape.gap2060;
    var uEnd = tape.positions[endYd] / tape.gap2060;
    var power = solveSpanPower(uStart, uEnd, measuredSpan / measuredGap);
    if (power == null) return null;
    return { power: power, gapIn: measuredGap, unitGap: tape.gap2060 };
  }

  function scaledIn(tape, yard, scale, ecc, shape) {
    var pos = tape.positions[yard];
    if (pos == null) return null;
    var eccFactor = ecc || 1;
    var unitGap = shape && shape.unitGap > 0 ? shape.unitGap : tape.gap2060;
    if (shape && shape.power > 0 && shape.gapIn > 0 && unitGap > 0) {
      return signedPow(pos / unitGap, shape.power) * shape.gapIn * eccFactor;
    }
    return pos * (scale || 1) * eccFactor;
  }

  function resolveTape(spec, startYd, endYd, balOpts, sightOpts) {
    return buildTape(spec.fps, endYd, startYd, balOpts, sightOpts);
  }

  function printEccFactor(promised, actual) {
    var p = promised != null && promised > 0 ? promised : 1;
    var a = actual != null && actual > 0 ? actual : 1;
    return p / a;
  }

  function setFill(el) {
    if (!el || el.type !== 'range') return;
    var min = parseFloat(el.min);
    var max = parseFloat(el.max);
    var val = parseFloat(el.value);
    if (!isFinite(min) || !isFinite(max) || max === min || !isFinite(val)) return;
    el.style.setProperty('--stc-fill', ((val - min) / (max - min)) * 100 + '%');
  }

  function setChip(el, text) {
    if (el) el.textContent = text;
  }

  function fpsFromUrl() {
    try {
      var q = new URLSearchParams(window.location.search).get('fps');
      if (q == null || q === '') return null;
      var v = parseFloat(q);
      return isFinite(v) ? clamp(v, FPS_MIN, FPS_MAX) : null;
    } catch (e) {
      return null;
    }
  }

  function svgEscape(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function textAnchor(align) {
    if (align === 'left') return 'start';
    if (align === 'right') return 'end';
    return 'middle';
  }

  function textX(align, tapeW, pad) {
    if (align === 'left') return pad;
    if (align === 'right') return tapeW - pad;
    return tapeW / 2;
  }

  function tickCenterX(tickAlign, tapeW, pad, maxHalf) {
    var half = maxHalf || 9;
    if (tickAlign === 'left') return pad + half;
    if (tickAlign === 'right') return tapeW - pad - half;
    return tapeW / 2;
  }

  function yardsForDrawing(startYd, endYd, tickStep) {
    if (tickStep <= 1) return tickYards(startYd, endYd, tickStep);
    var out = [];
    for (var y = startYd; y <= endYd; y++) out.push(y);
    return out;
  }

  function isIntermediateSubTick(yd, tickStep, isTen, isFive) {
    if (isTen || isFive) return false;
    if ((tickStep || 2) >= 2 && yd % tickStep === 0) return false;
    return true;
  }

  function resolveTickWidthPct(pct) {
    var n = pct != null && isFinite(pct) ? pct : DEFAULT_TICK_WIDTH_PCT;
    return clamp(n, TICK_WIDTH_PCT_MIN, TICK_WIDTH_PCT_MAX);
  }

  function tapeMetrics(tapeW, tickWidthPct) {
    var w = tapeW > 0 ? tapeW : DEFAULT_TAPE_WIDTH * PREVIEW_PX_PER_IN;
    var pad = clamp(w * 0.08, 2.4, 8);
    var inner = Math.max(w - 2 * pad, 4);
    var spanFrac = resolveTickWidthPct(tickWidthPct) / 100;
    var majorHalf = inner * spanFrac * 0.5;
    return {
      sidePad: pad,
      borderInset: clamp(w * 0.055, 2, 6),
      majorHalf: majorHalf,
      fiveHalf: majorHalf * TICK_FIVE_TO_MAJOR,
      subHalf: majorHalf * TICK_SUB_TO_MAJOR,
    };
  }

  function tickLineEndpoints(cx, isTen, isFive, subTickAlign, mode, yd, tickStep, metrics, tickAlign) {
    var m = metrics || {};
    var majorHalf = m.majorHalf != null ? m.majorHalf : mode === 'print' ? 0.14 : 9;
    var fiveHalf = m.fiveHalf != null ? m.fiveHalf : mode === 'print' ? 0.1 : 7;
    var subHalf = m.subHalf != null ? m.subHalf : mode === 'print' ? 0.06 : 3;
    var half = isTen
      ? majorHalf
      : isFive || !isIntermediateSubTick(yd, tickStep, isTen, isFive)
        ? fiveHalf
        : subHalf;
    var isSub = isIntermediateSubTick(yd, tickStep, isTen, isFive);
    if (isSub && subTickAlign === 'left') {
      return { x1: cx - majorHalf, x2: cx - majorHalf + subHalf * 2 };
    }
    if (isSub && subTickAlign === 'right') {
      return { x1: cx + majorHalf - subHalf * 2, x2: cx + majorHalf };
    }
    if (tickAlign === 'left') {
      var left = cx - majorHalf;
      return { x1: left, x2: left + half * 2 };
    }
    if (tickAlign === 'right') {
      var right = cx + majorHalf;
      return { x1: right - half * 2, x2: right };
    }
    return { x1: cx - half, x2: cx + half };
  }

  function tickStrokeWidth(isTen, isFive, mode, yd, tickStep) {
    var isSub = isIntermediateSubTick(yd, tickStep, isTen, isFive);
    if (mode === 'print') return isTen ? 0.022 : isFive || !isSub ? 0.016 : 0.008;
    return isTen ? 1.5 : isFive || !isSub ? 1.2 : 0.65;
  }

  function tickStrokeColor(isFive, tick, tickFive, fiveTickColorOn) {
    if (isFive && fiveTickColorOn && tickFive) return tickFive;
    return tick;
  }

  function isFiveYardLabel(yd) {
    return yd % 5 === 0 && yd % 10 !== 0;
  }

  function labelFillColor(yd, opts) {
    var text = opts.text || DEFAULT_TEXT;
    if (isFiveYardLabel(yd) && opts.fiveLabelColorOn && opts.textFive) return opts.textFive;
    return text;
  }

  function shouldLabelYard(yd, labelStep) {
    if (yd % 10 === 0) return true;
    if (labelStep === 5 && yd % 5 === 0) return true;
    return false;
  }

  function labelAlignForYard(yd, splitLabels, defaultAlign, labelStep) {
    if (!splitLabels) return defaultAlign;
    if (labelStep >= 5 && yd % 5 === 0 && yd % 10 !== 0) return 'left';
    if (yd % 10 !== 0) return defaultAlign;
    var decade = Math.floor(yd / 10);
    return decade % 2 === 0 ? 'right' : 'left';
  }

  function appendYardLabel(parts, yd, py, opts) {
    var tapeW = opts.tapeW;
    var sidePad = opts.sidePad;
    var splitLabels = !!opts.splitLabels;
    var align = opts.align || 'center';
    var labelStep = opts.labelStep === 5 ? 5 : 10;
    var labelOffsetPx = opts.labelOffsetPx || 0;
    var mode = opts.mode || 'preview';
    var labelScale = opts.labelScale != null && opts.labelScale > 0 ? opts.labelScale : 1;
    var padTop = opts.padTop;
    var contentHeight = opts.contentHeight;
    var text = opts.text;
    var yardAlign = labelAlignForYard(yd, splitLabels, align, labelStep);
    var availW =
      splitLabels && opts.laneW != null && opts.laneW > 0
        ? opts.laneW
        : Math.max(0, tapeW - 2 * sidePad);
    var fontSize = labelFontSize(yd, mode, labelScale);
    var digits = labelDigitsForYard(yd);
    var textW = labelTextWidth(digits, fontSize);
    if (availW > 0 && textW > availW * 0.96) {
      fontSize = fontSize * ((availW * 0.96) / textW);
      textW = labelTextWidth(digits, fontSize);
    }
    if (mode === 'print' && splitLabels && (availW <= 0 || textW > availW * 0.98)) {
      splitLabels = false;
      yardAlign = align || 'center';
      availW = Math.max(0, tapeW - 2 * sidePad);
      fontSize = labelFontSize(yd, mode, labelScale);
      textW = labelTextWidth(digits, fontSize);
      if (availW > 0 && textW > availW * 0.96) {
        fontSize = fontSize * ((availW * 0.96) / textW);
      }
    }
    var y = guardedLabelY(py, labelOffsetPx, mode, fontSize, padTop, contentHeight);
    var fontCss = mode === 'print' ? fontSize + 'in' : fontSize + 'px';
    parts.push(
      '<text x="' +
        textX(yardAlign, tapeW, sidePad) +
        '" y="' +
        y +
        '" text-anchor="' +
        textAnchor(yardAlign) +
        '" font-size="' +
        fontSize +
        '" style="font-size:' +
        fontCss +
        ';font-family:system-ui,sans-serif" font-family="system-ui,sans-serif"' +
        (mode === 'print' ? ' dominant-baseline="alphabetic"' : '') +
        ' fill="' +
        labelFillColor(yd, opts) +
        '">' +
        yd +
        '</text>'
    );
  }

  var LABEL_OFFSET_MIN = -10;
  var LABEL_OFFSET_MAX = 10;
  var LABEL_SIZE_PCT_MIN = 80;
  var LABEL_SIZE_PCT_MAX = 200;
  var TAPE_WIDTH_MIN = 0.25;
  var TAPE_WIDTH_MAX = 1.75;
  var DEFAULT_TAPE_WIDTH = 0.35;
  var TICK_WIDTH_PCT_MIN = 20;
  var TICK_WIDTH_PCT_MAX = 100;
  var DEFAULT_TICK_WIDTH_PCT = 68;
  var TICK_FIVE_TO_MAJOR = 0.22 / 0.34;
  var TICK_SUB_TO_MAJOR = 0.1 / 0.34;
  var PREVIEW_PX_PER_IN = 96;
  var PREVIEW_LABEL_TEN = 14;
  var PREVIEW_LABEL_FIVE = 11;
  var PRINT_LABEL_TEN = 0.14;
  var PRINT_LABEL_FIVE = 0.11;
  var PREVIEW_LABEL_BASE = 4;
  var PRINT_LABEL_BASE = 0.045;
  var PRINT_LABEL_OFFSET_PER_PX = 0.01125;
  var PREVIEW_LABEL_GUARD = 2;
  var PRINT_LABEL_GUARD = 0.02;
  var LABEL_CHAR_WIDTH_RATIO = 0.62;
  var LABEL_SCALE_FLOOR = 0.45;
  var PRINT_LABEL_SCALE_FLOOR = 0.38;

  function labelDigitsForYard(yd) {
    return String(yd).length;
  }

  function maxLabelDigits(endYd, splitLabels) {
    var digits = labelDigitsForYard(endYd || 80);
    if (!splitLabels) return digits;
    return digits >= 3 ? 3 : 2;
  }

  function previewTapeW(printWidthIn, pxPerIn) {
    var ppi = pxPerIn != null && pxPerIn > 0 ? pxPerIn : PREVIEW_PX_PER_IN;
    return (printWidthIn != null && printWidthIn > 0 ? printWidthIn : DEFAULT_TAPE_WIDTH) * ppi;
  }

  function labelLaneWidth(tapeW, sidePad, splitLabels, tickAlign, mode, majorHalf) {
    var tickHalf = majorHalf != null ? majorHalf : mode === 'print' ? 0.14 : 9;
    var cx = tickCenterX(tickAlign, tapeW, sidePad, tickHalf);
    if (splitLabels) {
      return Math.max(
        0,
        Math.min(cx - sidePad - tickHalf, tapeW - sidePad - cx - tickHalf)
      );
    }
    return Math.max(0, tapeW - 2 * sidePad);
  }

  function labelTextWidth(digits, fontSize) {
    return digits * LABEL_CHAR_WIDTH_RATIO * fontSize;
  }

  function splitLabelsFit(tapeW, sidePad, tickAlign, endYd, mode, labelSizePct) {
    var laneW = labelLaneWidth(tapeW, sidePad, true, tickAlign, mode);
    if (laneW <= 0) return false;
    var baseTen = mode === 'print' ? PRINT_LABEL_TEN : PREVIEW_LABEL_TEN;
    var digits = maxLabelDigits(endYd, true);
    var floor = mode === 'print' ? PRINT_LABEL_SCALE_FLOOR : LABEL_SCALE_FLOOR;
    var sizePct = labelSizePct != null ? labelSizePct : 100;
    var fontSize = baseTen * floor * (sizePct / 100);
    return labelTextWidth(digits, fontSize) <= laneW * 0.96;
  }

  function resolveSplitLabels(opts, mode) {
    if (!opts.splitLabels) return false;
    var tapeW = opts.tapeW || (mode === 'print' ? DEFAULT_TAPE_WIDTH : previewTapeW(opts.printWidthIn));
    var metrics = tapeMetrics(mode === 'print' ? tapeW * PREVIEW_PX_PER_IN : tapeW, opts.tickWidthPct);
    var sidePad = opts.sidePad != null ? opts.sidePad : mode === 'print' ? metrics.sidePad / PREVIEW_PX_PER_IN : metrics.sidePad;
    if (mode === 'print' && tapeW < 0.55) return false;
    return splitLabelsFit(
      tapeW,
      sidePad,
      opts.tickAlign || 'center',
      opts.endYd || 80,
      mode,
      opts.labelSizePct
    );
  }

  function resolveLabelScale(opts, mode) {
    opts = opts || {};
    var tapeW = opts.tapeW || (mode === 'print' ? DEFAULT_TAPE_WIDTH : previewTapeW(opts.printWidthIn));
    var metrics = tapeMetrics(mode === 'print' ? tapeW * PREVIEW_PX_PER_IN : tapeW, opts.tickWidthPct);
    var sidePad = opts.sidePad != null ? opts.sidePad : mode === 'print' ? metrics.sidePad / PREVIEW_PX_PER_IN : metrics.sidePad;
    var splitLabels = resolveSplitLabels(
      {
        splitLabels: !!opts.splitLabels,
        tapeW: tapeW,
        sidePad: sidePad,
        tickAlign: opts.tickAlign || 'center',
        endYd: opts.endYd || 80,
        labelSizePct: opts.labelSizePct,
        tickWidthPct: opts.tickWidthPct,
      },
      mode
    );
    var baseTen = mode === 'print' ? PRINT_LABEL_TEN : PREVIEW_LABEL_TEN;
    var laneW = labelLaneWidth(
      tapeW,
      sidePad,
      splitLabels,
      opts.tickAlign || 'center',
      mode,
      mode === 'print' ? metrics.majorHalf / PREVIEW_PX_PER_IN : metrics.majorHalf
    );
    var digits = maxLabelDigits(opts.endYd || 80, splitLabels);
    var estTextW = labelTextWidth(digits, baseTen);
    var fitScale = estTextW > 0 ? (laneW * 0.92) / estTextW : 1;
    var widthScale = tapeW > 0 ? (tapeW * 0.24) / baseTen : 1;
    var floor = mode === 'print' ? PRINT_LABEL_SCALE_FLOOR : LABEL_SCALE_FLOOR;
    var autoScale = clamp(Math.min(fitScale, widthScale), floor, 1.05);
    var labelSizePct = opts.labelSizePct != null ? opts.labelSizePct : 100;
    return autoScale * (labelSizePct / 100);
  }

  function labelTextY(py, labelOffsetPx, mode) {
    var offset = labelOffsetPx || 0;
    if (mode === 'print') {
      return py + PRINT_LABEL_BASE + offset * PRINT_LABEL_OFFSET_PER_PX;
    }
    return py + PREVIEW_LABEL_BASE + offset;
  }

  function guardedLabelY(py, labelOffsetPx, mode, fontSize, padTop, contentHeight) {
    var y = labelTextY(py, labelOffsetPx, mode);
    var guard = mode === 'print' ? PRINT_LABEL_GUARD : PREVIEW_LABEL_GUARD;
    var ascender = fontSize * 0.82;
    var minY = padTop + ascender + guard;
    var maxY = padTop + contentHeight - guard;
    if (minY > maxY) return py;
    return clamp(y, minY, maxY);
  }

  function labelFontSize(yd, mode, labelScale) {
    var scale = labelScale != null && labelScale > 0 ? labelScale : 1;
    if (mode === 'print') {
      return (yd % 10 === 0 ? PRINT_LABEL_TEN : PRINT_LABEL_FIVE) * scale;
    }
    return (yd % 10 === 0 ? PREVIEW_LABEL_TEN : PREVIEW_LABEL_FIVE) * scale;
  }

  function labelBounds(py, labelOffsetPx, mode, fontSize, padTop, contentHeight) {
    var y = guardedLabelY(py, labelOffsetPx, mode, fontSize, padTop, contentHeight);
    var ascender = fontSize * 0.82;
    var descender = fontSize * 0.2;
    var pad = mode === 'print' ? PRINT_LABEL_GUARD * 0.5 : PREVIEW_LABEL_GUARD * 0.5;
    return { y: y, top: y - ascender - pad, bottom: y + descender + pad };
  }

  function labelLane(yd, splitLabels, defaultAlign, labelStep) {
    if (!splitLabels) return 'shared';
    return labelAlignForYard(yd, splitLabels, defaultAlign, labelStep);
  }

  function labelsOverlap(a, b) {
    return !(a.bottom <= b.top || b.bottom <= a.top);
  }

  function visibleLabelYards(marks, tape, scale, opts, mode, layout) {
    opts = opts || {};
    layout = layout || {};
    var labelStep = opts.labelStep === 5 ? 5 : 10;
    var splitLabels = !!opts.splitLabels;
    var align = opts.align || 'center';
    var labelOffsetPx = opts.labelOffsetPx || 0;
    var labelScale =
      opts.labelScale != null
        ? opts.labelScale
        : resolveLabelScale(
            {
              tapeW: layout.tapeW,
              sidePad: layout.sidePad,
              splitLabels: splitLabels,
              tickAlign: opts.tickAlign,
              endYd: opts.endYd,
              labelSizePct: opts.labelSizePct,
              tickWidthPct: opts.tickWidthPct,
              printWidthIn: opts.printWidthIn,
            },
            mode
          );
    var bounds = layout.bounds;
    var padTop = layout.padTop;
    var contentHeight = layout.contentHeight;
    var ecc = layout.ecc || 1;
    var pxPerIn = layout.pxPerIn || 1;
    var candidates = [];

    for (var i = 0; i < marks.length; i++) {
      var yd = marks[i];
      if (!shouldLabelYard(yd, labelStep)) continue;
      var inch = scaledIn(tape, yd, scale, ecc, opts.markShape);
      if (inch == null) continue;
      var py =
        mode === 'print'
          ? padTop + (inch - bounds.minIn)
          : padTop + (inch - bounds.minIn) * pxPerIn;
      var fontSize = labelFontSize(yd, mode, labelScale);
      var box = labelBounds(py, labelOffsetPx, mode, fontSize, padTop, contentHeight);
      candidates.push({
        yd: yd,
        lane: labelLane(yd, splitLabels, align, labelStep),
        top: box.top,
        bottom: box.bottom,
        priority: yd % 10 === 0 ? 0 : 1,
      });
    }

    candidates.sort(function (a, b) {
      if (a.priority !== b.priority) return a.priority - b.priority;
      return a.top - b.top;
    });

    var placed = [];
    var visible = {};
    for (var c = 0; c < candidates.length; c++) {
      var cand = candidates[c];
      var blocked = false;
      for (var p = 0; p < placed.length; p++) {
        var prev = placed[p];
        if (prev.lane !== 'shared' && cand.lane !== 'shared' && prev.lane !== cand.lane) continue;
        if (labelsOverlap(cand, prev)) {
          blocked = true;
          break;
        }
      }
      if (!blocked) {
        placed.push(cand);
        visible[cand.yd] = true;
      }
    }
    return visible;
  }

  function tapeBoundsInches(tape, scale, startYd, endYd, ecc, shape) {
    var minIn = Infinity;
    var maxIn = -Infinity;
    for (var y = startYd; y <= endYd; y++) {
      var inches = scaledIn(tape, y, scale, ecc, shape);
      if (inches == null) continue;
      if (inches < minIn) minIn = inches;
      if (inches > maxIn) maxIn = inches;
    }
    if (!isFinite(minIn) || !isFinite(maxIn)) {
      return { minIn: 0, maxIn: 0, span: 0 };
    }
    return { minIn: minIn, maxIn: maxIn, span: maxIn - minIn };
  }

  function tapeSpanInches(tape, scale, startYd, endYd, ecc, shape) {
    return tapeBoundsInches(tape, scale, startYd, endYd, ecc, shape).span;
  }

  function tapeMeasureSummary(tape, opts) {
    opts = opts || {};
    var startYd = opts.startYd || 20;
    var endYd = opts.endYd || 80;
    var measuredGap = opts.measuredGap;
    var printScale = !!opts.printScale;
    var printEcc = opts.printEcc || 1;
    var hasMeasuredGap = measuredGap != null && measuredGap > 0;
    var hasMeasuredSpan = opts.measuredSpan != null && opts.measuredSpan > 0;
    var nativeBounds = tapeBoundsInches(tape, 1, startYd, endYd, 1);
    var lengthResolved = resolveLengthScale(tape, {
      measuredGap: measuredGap,
    });
    var gapScale = lengthResolved.method === 'gap' ? lengthResolved.scale : null;
    var printSpanScale = !printScale ? 1 : lengthResolved.scale;
    var printEccApplied = printScale ? printEcc : 1;
    var markShape = printScale ? opts.markShape : null;
    var printBounds = tapeBoundsInches(tape, printSpanScale, startYd, endYd, printEccApplied, markShape);
    var scaledBounds =
      lengthResolved.scale !== 1
        ? tapeBoundsInches(tape, lengthResolved.scale, startYd, endYd, printEcc)
        : null;
    var padTop = opts.printStartOffset != null ? opts.printStartOffset : 0.07;
    var padBot = 0.08;
    return {
      startYd: startYd,
      endYd: endYd,
      nativeSpan: nativeBounds.span,
      nativeMin: nativeBounds.minIn,
      nativeMax: nativeBounds.maxIn,
      gap2060Ballistic: tape.gap2060,
      measuredGap2060: hasMeasuredGap ? measuredGap : null,
      measuredSpanIn: hasMeasuredSpan ? opts.measuredSpan : null,
      scaleMethod: lengthResolved.method,
      gapScaleFactor: lengthResolved.scale !== 1 ? lengthResolved.scale : null,
      scaledSpan: scaledBounds ? scaledBounds.span : null,
      scaledMin: scaledBounds ? scaledBounds.minIn : null,
      scaledMax: scaledBounds ? scaledBounds.maxIn : null,
      printSpan: printBounds.span,
      printMin: printBounds.minIn,
      printMax: printBounds.maxIn,
      printSvgHeight: printBounds.span + padTop + padBot,
      printEcc: printEccApplied,
      printMode: printScale ? (markShape ? 'shaped' : 'scaled') : 'native',
      spanPower: markShape ? markShape.power : null,
      labelScale: opts.labelScale,
      sightPeepToSight: opts.sightPeepToSight,
      sightPeepHeight: opts.sightPeepHeight,
      sightLabel: opts.sightLabel,
      densityAltFt: opts.densityAltFt,
    };
  }

  function measureRow(label, value) {
    return (
      '<div class="stc-calc__measure-row"><dt>' +
      svgEscape(label) +
      '</dt><dd>' +
      svgEscape(value) +
      '</dd></div>'
    );
  }

  function renderMeasureSummary(summary) {
    if (!summary) return '';
    var parts = ['<dl class="stc-calc__measure-grid">'];
    parts.push(
      measureRow(
        'Yardage range',
        summary.startYd + '–' + summary.endYd + ' yd'
      )
    );
    parts.push(
      measureRow(
        'Native span (predicted)',
        fmt(summary.nativeSpan, 3) + '" (' + fmt(summary.nativeMin, 3) + '" to ' + fmt(summary.nativeMax, 3) + '")'
      )
    );
    if (summary.gap2060Ballistic > 0) {
      parts.push(
        measureRow(
          'Predicted 20–60 gap',
          fmt(summary.gap2060Ballistic, 3) + '" (chrono + arrow + sight geometry)'
        )
      );
    }
    if (summary.sightPeepToSight != null && summary.sightPeepHeight != null) {
      parts.push(
        measureRow(
          'Peep geometry',
          fmt(summary.sightPeepToSight, 2) +
            '" peep-to-sight · ' +
            fmt(summary.sightPeepHeight, 2) +
            '" peep height'
        )
      );
    }
    if (summary.sightLabel) {
      parts.push(measureRow('Sight preset', summary.sightLabel));
    }
    if (summary.densityAltFt != null && summary.densityAltFt > 0) {
      parts.push(measureRow('Density altitude', Math.round(summary.densityAltFt) + ' ft'));
    }
    if (summary.measuredGap2060 != null) {
      parts.push(measureRow('Your 20–60 gap', fmt(summary.measuredGap2060, 3) + '"'));
    }
    if (summary.measuredSpanIn != null) {
      parts.push(measureRow('Your tape span', fmt(summary.measuredSpanIn, 3) + '" tick to tick'));
    }
    if (summary.gapScaleFactor != null) {
      parts.push(
        measureRow(
          'Gap scale factor',
          fmt(summary.gapScaleFactor, 5) + '× (your gap ÷ ballistic gap)'
        )
      );
      parts.push(
        measureRow(
          'Scaled span',
          fmt(summary.scaledSpan, 3) +
            '" (' +
            fmt(summary.scaledMin, 3) +
            '" to ' +
            fmt(summary.scaledMax, 3) +
            '")'
        )
      );
    }
    if (summary.spanPower != null && summary.spanPower !== 1) {
      parts.push(
        measureRow(
          'Span shape',
          fmt(summary.spanPower, 3) + ' power (20 and 60 stay on the gap; farther marks spread to your tape)'
        )
      );
    }
    parts.push(
      measureRow(
        'Print span (this sheet)',
        fmt(summary.printSpan, 3) +
          '" (' +
          fmt(summary.printMin, 3) +
          '" to ' +
          fmt(summary.printMax, 3) +
          '") · ' +
          (summary.printMode === 'shaped'
            ? '20–60 gap held, marks stretched to your tape span'
            : summary.printMode === 'scaled'
              ? 'scaled to 20–60 gap'
              : 'native spacing')
      )
    );
    parts.push(
      measureRow(
        'Print SVG height',
        fmt(summary.printSvgHeight, 3) + '" (span + top/bottom padding)'
      )
    );
    if (summary.printEcc !== 1) {
      parts.push(measureRow('Print correction', fmt(summary.printEcc, 4) + '× applied to print span'));
    }
    if (summary.labelScale != null) {
      parts.push(
        measureRow(
          'Label scale',
          fmt(summary.labelScale * 100, 1) + '% (auto-fits tape width × slider)'
        )
      );
    }
    parts.push('</dl>');
    return parts.join('');
  }

  function previewPxPerIn(maxIn) {
    var target = 480;
    var px = PREVIEW_PX_PER_IN;
    if (maxIn * px > target && maxIn > 0) px = target / maxIn;
    return Math.max(px, 24);
  }

  function previewScaleNote(pxPerIn, displaySpan, lengthScale) {
    var rounded = Math.round(pxPerIn);
    var atTrueSize = pxPerIn >= PREVIEW_PX_PER_IN - 0.5;
    var zoomHint = atTrueSize
      ? ' · at 100% browser zoom, 1″ bar = 1″ on screen'
      : ' · preview compressed — 1″ bar is tape scale, not screen inches';
    if (lengthScale !== 1) {
      return (
        'Preview matches print — scaled to your 20–60 gap · ~' +
        fmt(displaySpan, 2) +
        '" span · ' +
        rounded +
        ' px/in' +
        zoomHint
      );
    }
    return (
      'Native spacing (enter a 20–60 gap to match print scale) · ' +
      rounded +
      ' px/in · use 1″ bar below' +
      zoomHint
    );
  }

  function renderPreviewScaleBar(pxPerIn) {
    var w = pxPerIn;
    return (
      '<div class="stc-calc__preview-scale" aria-label="One inch reference on this preview">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="' +
      (w + 8) +
      '" height="18" role="img" aria-hidden="true">' +
      '<line x1="4" y1="9" x2="' +
      (w + 4) +
      '" y2="9" stroke="currentColor" stroke-width="2"/>' +
      '<text x="' +
      (w / 2 + 4) +
      '" y="7" text-anchor="middle" font-size="9" fill="currentColor">1″</text>' +
      '</svg></div>'
    );
  }

  function renderTapeSvg(tape, scale, opts) {
    opts = opts || {};
    var startYd = opts.startYd || 20;
    var endYd = opts.endYd || 80;
    var bg = opts.bg || DEFAULT_BG;
    var text = opts.text || DEFAULT_TEXT;
    var tick = opts.tick || DEFAULT_TICK;
    var tickFive = opts.tickFive || DEFAULT_TICK_FIVE;
    var fiveTickColorOn = !!opts.fiveTickColorOn;
    var align = opts.align || 'center';
    var tickAlign = opts.tickAlign || 'center';
    var subTickAlign = opts.subTickAlign || 'center';
    var labelStep = opts.labelStep === 5 ? 5 : 10;
    var tapeW = opts.tapeW || previewTapeW(opts.printWidthIn, opts.pxPerIn);
    var metrics = tapeMetrics(tapeW, opts.tickWidthPct);
    var sidePad = metrics.sidePad;
    var splitLabels = resolveSplitLabels(
      {
        splitLabels: !!opts.splitLabels,
        tapeW: tapeW,
        sidePad: sidePad,
        tickAlign: tickAlign,
        endYd: endYd,
        labelSizePct: opts.labelSizePct,
        tickWidthPct: opts.tickWidthPct,
      },
      'preview'
    );
    var labelOffsetPx = opts.labelOffsetPx || 0;
    var printEcc = opts.printEcc || 1;
    var padTop = 10;
    var padBot = 14;
    var tickStep = opts.tickStep || 2;
    var marks = yardsForDrawing(startYd, endYd, tickStep);
    var bounds = tapeBoundsInches(tape, scale, startYd, endYd, printEcc, opts.markShape);
    var spanIn = bounds.span;
    var pxPerIn = opts.pxPerIn || previewPxPerIn(spanIn);
    var tapeH = Math.max(spanIn * pxPerIn + padTop + padBot, 120);
    var cx = tickCenterX(tickAlign, tapeW, sidePad, metrics.majorHalf);
    var contentHeight = spanIn * pxPerIn;
    var labelLane = labelLaneWidth(tapeW, sidePad, splitLabels, tickAlign, 'preview', metrics.majorHalf);
    var labelScale = resolveLabelScale(
      {
        tapeW: tapeW,
        sidePad: sidePad,
        splitLabels: splitLabels,
        tickAlign: tickAlign,
        endYd: endYd,
        labelSizePct: opts.labelSizePct,
        tickWidthPct: opts.tickWidthPct,
        printWidthIn: opts.printWidthIn,
      },
      'preview'
    );
    opts.labelScale = labelScale;
    opts.splitLabels = splitLabels;
    var labelVisibility = visibleLabelYards(marks, tape, scale, opts, 'preview', {
      bounds: bounds,
      padTop: padTop,
      contentHeight: contentHeight,
      pxPerIn: pxPerIn,
      tapeW: tapeW,
      sidePad: sidePad,
      ecc: printEcc,
    });
    var parts = [];
    parts.push(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' +
        tapeW +
        ' ' +
        tapeH +
        '" width="' +
        tapeW +
        '" height="' +
        tapeH +
        '" role="img" aria-label="Sight tape ' +
        tape.fps +
        ' fps" overflow="hidden" style="overflow:hidden">'
    );
    parts.push('<rect width="100%" height="100%" fill="' + bg + '"/>');
    parts.push(
      '<rect x="' +
        metrics.borderInset +
        '" y="' +
        padTop +
        '" width="' +
        Math.max(tapeW - metrics.borderInset * 2, 1) +
        '" height="' +
        Math.max(spanIn * pxPerIn, 1) +
        '" fill="none" stroke="' +
        tick +
        '" stroke-width="1"/>'
    );

    for (var i = 0; i < marks.length; i++) {
      var yd = marks[i];
      var inch = scaledIn(tape, yd, scale, printEcc, opts.markShape);
      if (inch == null) continue;
      var py = padTop + (inch - bounds.minIn) * pxPerIn;
      var isTen = yd % 10 === 0;
      var isFive = yd % 5 === 0 && !isTen;
      var span = tickLineEndpoints(cx, isTen, isFive, subTickAlign, 'preview', yd, tickStep, metrics, tickAlign);
      parts.push(
        '<line x1="' +
          span.x1 +
          '" y1="' +
          py +
          '" x2="' +
          span.x2 +
          '" y2="' +
          py +
          '" stroke="' +
          tickStrokeColor(isFive, tick, tickFive, fiveTickColorOn) +
          '" stroke-width="' +
          tickStrokeWidth(isTen, isFive, 'preview', yd, tickStep) +
          '"/>'
      );
      if (labelVisibility[yd]) {
        appendYardLabel(parts, yd, py, {
          tapeW: tapeW,
          sidePad: sidePad,
          splitLabels: splitLabels,
          laneW: splitLabels ? labelLane : null,
          align: align,
          labelStep: labelStep,
          labelOffsetPx: labelOffsetPx,
          mode: 'preview',
          labelScale: labelScale,
          padTop: padTop,
          contentHeight: contentHeight,
          text: text,
          textFive: opts.textFive || DEFAULT_TEXT_FIVE,
          fiveLabelColorOn: !!opts.fiveLabelColorOn,
        });
      }
    }
    parts.push('</svg>');
    return parts.join('');
  }

  function renderPrintTape(tape, scale, opts) {
    opts = opts || {};
    var dpi = PREVIEW_PX_PER_IN;
    var startYd = opts.startYd || 20;
    var endYd = opts.endYd || 80;
    var bg = opts.bg || DEFAULT_BG;
    var text = opts.text || DEFAULT_TEXT;
    var tick = opts.tick || DEFAULT_TICK;
    var tickFive = opts.tickFive || DEFAULT_TICK_FIVE;
    var fiveTickColorOn = !!opts.fiveTickColorOn;
    var align = opts.align || 'center';
    var tickAlign = opts.tickAlign || 'center';
    var subTickAlign = opts.subTickAlign || 'center';
    var labelStep = opts.labelStep === 5 ? 5 : 10;
    var tapeWIn = opts.tapeW || DEFAULT_TAPE_WIDTH;
    var tapeW = tapeWIn * dpi;
    var metrics = tapeMetrics(tapeW, opts.tickWidthPct);
    var sidePadIn = metrics.sidePad / dpi;
    var splitLabels = resolveSplitLabels(
      {
        splitLabels: !!opts.splitLabels,
        tapeW: tapeWIn,
        sidePad: sidePadIn,
        tickAlign: tickAlign,
        endYd: endYd,
        labelSizePct: opts.labelSizePct,
        tickWidthPct: opts.tickWidthPct,
      },
      'print'
    );
    var labelOffsetPx = opts.labelOffsetPx || 0;
    var printEcc = opts.printEcc || 1;
    var tickStep = opts.tickStep || 2;
    var marks = yardsForDrawing(startYd, endYd, tickStep);
    var bounds = tapeBoundsInches(tape, scale, startYd, endYd, printEcc, opts.markShape);
    var spanIn = bounds.span;
    var padTopIn = opts.printStartOffset != null ? opts.printStartOffset : 0.08;
    var padBotIn = 0.08;
    var tapeHIn =
      opts.printMaxHeight != null && opts.printMaxHeight > 0
        ? opts.printMaxHeight
        : spanIn + padTopIn + padBotIn;
    var sidePad = metrics.sidePad;
    var padTop = padTopIn * dpi;
    var spanPx = spanIn * dpi;
    var tapeH = tapeHIn * dpi;
    var cx = tickCenterX(tickAlign, tapeW, sidePad, metrics.majorHalf);
    var labelLane = labelLaneWidth(tapeW, sidePad, splitLabels, tickAlign, 'preview', metrics.majorHalf);
    var labelScale = resolveLabelScale(
      {
        tapeW: tapeW,
        sidePad: sidePad,
        splitLabels: splitLabels,
        tickAlign: tickAlign,
        endYd: endYd,
        labelSizePct: opts.labelSizePct,
        tickWidthPct: opts.tickWidthPct,
        printWidthIn: tapeWIn,
      },
      'preview'
    );
    opts.labelScale = labelScale;
    opts.splitLabels = splitLabels;
    var labelVisibility = visibleLabelYards(marks, tape, scale, opts, 'preview', {
      bounds: bounds,
      padTop: padTop,
      contentHeight: spanPx,
      ecc: printEcc,
      tapeW: tapeW,
      sidePad: sidePad,
      pxPerIn: dpi,
    });
    var parts = [];
    parts.push(
      '<svg xmlns="http://www.w3.org/2000/svg" width="' +
        tapeWIn +
        'in" height="' +
        tapeHIn +
        'in" viewBox="0 0 ' +
        tapeW +
        ' ' +
        tapeH +
        '" overflow="hidden" style="--stc-tape-w:' +
        tapeWIn +
        'in;--stc-tape-h:' +
        tapeHIn +
        'in">'
    );
    parts.push('<rect width="100%" height="100%" fill="' + bg + '"/>');
    parts.push(
      '<rect x="' +
        metrics.borderInset +
        '" y="' +
        padTop +
        '" width="' +
        Math.max(tapeW - metrics.borderInset * 2, 1) +
        '" height="' +
        Math.max(spanPx, 1) +
        '" fill="none" stroke="' +
        tick +
        '" stroke-width="' +
        0.015 * dpi +
        '"/>'
    );

    for (var i = 0; i < marks.length; i++) {
      var yd = marks[i];
      var inch = scaledIn(tape, yd, scale, printEcc, opts.markShape);
      if (inch == null) continue;
      var py = padTop + (inch - bounds.minIn) * dpi;
      if (opts.printMaxHeight != null && opts.printMaxHeight > 0 && py > tapeH) continue;
      var isTen = yd % 10 === 0;
      var isFive = yd % 5 === 0 && !isTen;
      var span = tickLineEndpoints(cx, isTen, isFive, subTickAlign, 'preview', yd, tickStep, metrics, tickAlign);
      parts.push(
        '<line x1="' +
          span.x1 +
          '" y1="' +
          py +
          '" x2="' +
          span.x2 +
          '" y2="' +
          py +
          '" stroke="' +
          tickStrokeColor(isFive, tick, tickFive, fiveTickColorOn) +
          '" stroke-width="' +
          tickStrokeWidth(isTen, isFive, 'preview', yd, tickStep) +
          '"/>'
      );
      if (labelVisibility[yd]) {
        appendYardLabel(parts, yd, py, {
          tapeW: tapeW,
          sidePad: sidePad,
          splitLabels: splitLabels,
          laneW: splitLabels ? labelLane : null,
          align: align,
          labelStep: labelStep,
          labelOffsetPx: labelOffsetPx,
          mode: 'preview',
          labelScale: labelScale,
          padTop: padTop,
          contentHeight: spanPx,
          text: text,
          textFive: opts.textFive || DEFAULT_TEXT_FIVE,
          fiveLabelColorOn: !!opts.fiveLabelColorOn,
        });
      }
    }
    parts.push('</svg>');
    return parts.join('');
  }

  function buildTapeSpecs(fps, count, mode) {
    count = clamp(count, 1, 9) || 5;
    var specs = [];
    if (mode === 'same') {
      for (var i = 0; i < count; i++) {
        specs.push({
          fps: fps,
          label: count > 1 ? fps + ' fps · ' + (i + 1) : fps + ' fps',
        });
      }
      return specs;
    }
    var half = Math.floor((count - 1) / 2);
    for (var o = -half; o <= half; o++) {
      if (specs.length >= count) break;
      var f = fps + o;
      specs.push({ fps: f, label: f + ' fps' });
    }
    return specs;
  }

  function shouldScalePrint(hasGap) {
    return !!hasGap;
  }

  function centerSpec(specs, centerFps) {
    if (!specs || !specs.length) return null;
    if (centerFps == null) return specs[Math.floor((specs.length - 1) / 2)];
    var best = specs[0];
    var bestDist = Math.abs(best.fps - centerFps);
    for (var i = 1; i < specs.length; i++) {
      var dist = Math.abs(specs[i].fps - centerFps);
      if (dist < bestDist) {
        best = specs[i];
        bestDist = dist;
      }
    }
    return best;
  }

  function renderLivePreview(specs, style, lengthScale, lengthEcc) {
    lengthScale = lengthScale != null && lengthScale > 0 ? lengthScale : 1;
    lengthEcc = lengthEcc || 1;
    var parts = [];
    var balOpts = balOptsFromStyle(style);
    var center = centerSpec(specs, style.centerFps);
    var refTape = resolveTape(center, style.startYd, style.endYd, balOpts, style.sightOpts);
    var refShape = style.markShape || null;
    var displaySpan = tapeSpanInches(
      refTape,
      lengthScale,
      style.startYd,
      style.endYd,
      lengthEcc,
      refShape
    );
    var maxSpan = displaySpan;
    var drawn = [];
    for (var s = 0; s < specs.length; s++) {
      var drawnTape = resolveTape(specs[s], style.startYd, style.endYd, balOpts, style.sightOpts);
      var drawnSpan = tapeSpanInches(
        drawnTape,
        lengthScale,
        style.startYd,
        style.endYd,
        lengthEcc,
        refShape
      );
      if (drawnSpan > maxSpan) maxSpan = drawnSpan;
      drawn.push({ spec: specs[s], tape: drawnTape });
    }
    var pxPerIn = previewPxPerIn(maxSpan);
    var printWidthIn = style.printWidthIn != null && style.printWidthIn > 0 ? style.printWidthIn : DEFAULT_TAPE_WIDTH;
    var previewStyle = Object.assign({}, style, {
      pxPerIn: pxPerIn,
      tapeW: printWidthIn * pxPerIn,
      printEcc: lengthEcc,
      markShape: refShape,
    });
    parts.push(
      '<p class="stc-calc__preview-scale-note">' +
        previewScaleNote(pxPerIn, displaySpan, lengthScale) +
        '</p>'
    );
    for (var t = 0; t < drawn.length; t++) {
      var spec = drawn[t].spec;
      parts.push('<div class="stc-calc__tape">');
      parts.push('<p class="stc-calc__tape-fps">' + svgEscape(spec.label) + '</p>');
      parts.push(renderTapeSvg(drawn[t].tape, lengthScale, previewStyle));
      parts.push('</div>');
    }
    parts.push(renderPreviewScaleBar(pxPerIn));
    return parts.join('');
  }

  function renderPrintSetupRow(label, value) {
    if (value == null || value === '' || value === '—') return '';
    return (
      '<div class="stc-print-preview__setup-row"><dt>' +
      svgEscape(label) +
      '</dt><dd>' +
      svgEscape(String(value)) +
      '</dd></div>'
    );
  }

  function renderPrintSetupSummary(fps, style, measurements) {
    var parts = ['<dl class="stc-print-preview__setup" data-stc-print-block="setup">'];
    parts.push(renderPrintSetupRow('Chrono speed', fps != null ? Math.round(fps) + ' fps' : null));
    parts.push(renderPrintSetupRow('Arrow weight', balOptsWeightLabel(balOptsFromStyle(style))));
    if (measurements && measurements.measuredGap2060 != null) {
      parts.push(renderPrintSetupRow('20–60 gap', fmt(measurements.measuredGap2060, 3) + '"'));
    }
    parts.push('</dl>');
    return parts.join('');
  }

  function renderPrintLogo(meta) {
    var logo = (meta && meta.logo) || '';
    var shop = (meta && meta.shop) || 'TitleX Archery';
    if (logo) {
      return (
        '<div data-stc-print-block="logo"><img class="stc-print-preview__logo" src="' +
        svgEscape(logo) +
        '" alt="' +
        svgEscape(shop) +
        '" width="180"></div>'
      );
    }
    return (
      '<p class="stc-print-preview__title" data-stc-print-block="logo">' + svgEscape(shop) + '</p>'
    );
  }

  function renderPrintScaleBar() {
    var dpi = PREVIEW_PX_PER_IN;
    var size = dpi * 2;
    var inset = 1;
    var inner = size - inset * 2;
    var mid = dpi;
    var tickMinor = Math.round(dpi * 0.1);
    var tickHalf = Math.round(dpi * 0.14);
    var parts = [];
    parts.push(
      '<rect x="' +
        inset +
        '" y="' +
        inset +
        '" width="' +
        inner +
        '" height="' +
        inner +
        '" fill="none" stroke="#000" stroke-width="2"/>'
    );
    parts.push(
      '<line x1="' +
        mid +
        '" y1="' +
        inset +
        '" x2="' +
        mid +
        '" y2="' +
        (size - inset) +
        '" stroke="#000" stroke-width="1.25"/>'
    );
    parts.push(
      '<line x1="' +
        inset +
        '" y1="' +
        mid +
        '" x2="' +
        (size - inset) +
        '" y2="' +
        mid +
        '" stroke="#000" stroke-width="1.25"/>'
    );
    var halfMarks = [0.5, 1.5];
    for (var i = 0; i < halfMarks.length; i++) {
      var pos = halfMarks[i] * dpi;
      parts.push(
        '<line x1="' +
          pos +
          '" y1="' +
          (size - inset) +
          '" x2="' +
          pos +
          '" y2="' +
          (size - inset - tickHalf) +
          '" stroke="#000" stroke-width="1.5"/>'
      );
      parts.push(
        '<line x1="' +
          pos +
          '" y1="' +
          inset +
          '" x2="' +
          pos +
          '" y2="' +
          (inset + tickHalf) +
          '" stroke="#000" stroke-width="1.5"/>'
      );
      parts.push(
        '<line x1="' +
          inset +
          '" y1="' +
          pos +
          '" x2="' +
          (inset + tickHalf) +
          '" y2="' +
          pos +
          '" stroke="#000" stroke-width="1.5"/>'
      );
      parts.push(
        '<line x1="' +
          (size - inset) +
          '" y1="' +
          pos +
          '" x2="' +
          (size - inset - tickHalf) +
          '" y2="' +
          pos +
          '" stroke="#000" stroke-width="1.5"/>'
      );
    }
    var q = dpi * 0.25;
    var q3 = dpi * 1.75;
    var qs = [q, q3];
    for (var qi = 0; qi < qs.length; qi++) {
      var qp = qs[qi];
      parts.push(
        '<line x1="' +
          qp +
          '" y1="' +
          (size - inset) +
          '" x2="' +
          qp +
          '" y2="' +
          (size - inset - tickMinor) +
          '" stroke="#000" stroke-width="1"/>'
      );
      parts.push(
        '<line x1="' +
          qp +
          '" y1="' +
          inset +
          '" x2="' +
          qp +
          '" y2="' +
          (inset + tickMinor) +
          '" stroke="#000" stroke-width="1"/>'
      );
      parts.push(
        '<line x1="' +
          inset +
          '" y1="' +
          qp +
          '" x2="' +
          (inset + tickMinor) +
          '" y2="' +
          qp +
          '" stroke="#000" stroke-width="1"/>'
      );
      parts.push(
        '<line x1="' +
          (size - inset) +
          '" y1="' +
          qp +
          '" x2="' +
          (size - inset - tickMinor) +
          '" y2="' +
          qp +
          '" stroke="#000" stroke-width="1"/>'
      );
    }
    return (
      '<div class="stc-calc__scale-bar" data-stc-print-block="scale" aria-label="Two inch by two inch scale check">' +
      '<p class="stc-calc__scale-bar-label">2 in × 2 in — outer square. Cross is 1 in. Check X and Y.</p>' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="2in" height="2in" viewBox="0 0 ' +
      size +
      ' ' +
      size +
      '" style="width:2in;height:2in;display:block;overflow:hidden">' +
      parts.join('') +
      '</svg></div>'
    );
  }

  function renderPrintQrBlock(meta) {
    if (!meta.shareUrl) return '';
    var parts = [];
    parts.push('<div class="stc-calc__print-qr" data-stc-print-block="qr">');
    parts.push('<div class="stc-calc__print-qr-code" data-stc-print-qr aria-hidden="true"></div>');
    parts.push('<div class="stc-calc__print-qr-copy">');
    parts.push('<strong>Reload this setup</strong>');
    parts.push('<p>Scan to reload these settings.</p>');
    if (meta.bowName) {
      parts.push('<p class="stc-calc__print-qr-bow">' + svgEscape(meta.bowName) + '</p>');
    }
    parts.push('</div></div>');
    return parts.join('');
  }

  function renderPrintHowto(count, labelPaper, useGapScale) {
    var parts = [];
    parts.push('<div class="stc-print-preview__howto" data-stc-print-block="howto">');
    parts.push('<strong>Before you cut</strong>');
    parts.push('<ol>');
    if (labelPaper) {
      parts.push(
        '<li>Print two <strong>4×6</strong> labels at <strong>100%</strong>. Pick 4×6 / 100×150 mm — not Letter. Turn off “Fit to page”.</li>'
      );
      parts.push('<li>Check the 2×2 in square on this label (X and Y). Adjust print correction if needed, then reprint.</li>');
      parts.push('<li>Cut the tape from the second label. Align 20 yd on your sight. Confirm 20–60 before you hunt.</li>');
    } else {
      parts.push('<li>Print at <strong>100%</strong> — turn off “Fit to page” / “Shrink to fit”.</li>');
      parts.push('<li>Check the 2×2 in square on both axes. Adjust print correction if needed, then reprint.</li>');
      parts.push(
        '<li>Cut one tape. Align 20 yd on your sight. Confirm 20–60 before you hunt.</li>'
      );
    }
    if (count > 1 && useGapScale) {
      parts.push(
        '<li>The center tape matches your 20–60 gap. Nearby speeds keep that same sight scale, so those tapes are a different length.</li>'
      );
    } else if (count > 1) {
      parts.push('<li>Pick the family tape whose 20–60 gap matches your sight.</li>');
    }
    parts.push('</ol>');
    parts.push('</div>');
    return parts.join('');
  }

  function renderPrintTapesBlock(specs, measuredGap, style, useGapScale) {
    var count = specs.length;
    var parts = [];
    parts.push('<div class="stc-calc__print-tapes" data-stc-print-block="tapes">');
    var showTapeLabels = count === 1;
    if (count > 1) {
      var labelSet = {};
      for (var li = 0; li < specs.length; li++) {
        var printLabel = specs[li].label;
        labelSet[printLabel] = true;
      }
      showTapeLabels = Object.keys(labelSet).length > 1;
    }
    for (var t = 0; t < specs.length; t++) {
      var spec = specs[t];
      var tape = resolveTape(spec, style.startYd, style.endYd, balOptsFromStyle(style), style.sightOpts);
      var scale = useGapScale && style.lengthScale > 0 ? style.lengthScale : 1;
      var printStyle = Object.assign({}, style, {
        tapeW: style.printWidthIn || DEFAULT_TAPE_WIDTH,
        printStartOffset: style.printStartOffset != null ? style.printStartOffset : 0.07,
        printEcc: style.printEcc || 1,
        printMaxHeight: style.printMaxHeight,
        markShape: useGapScale ? style.markShape || null : null,
      });
      parts.push('<div class="stc-calc__print-tape">');
      if (showTapeLabels) {
        parts.push(
          '<p class="stc-calc__print-tape-fps">' +
            svgEscape(spec.label) +
            '</p>'
        );
      }
      parts.push(renderPrintTape(tape, scale, printStyle));
      parts.push('</div>');
    }
    parts.push('</div>');
    return parts.join('');
  }

  function renderPrintPage(kind, screenLabel, inner) {
    return (
      '<div class="stc-print-page stc-print-page--' +
      kind +
      '">' +
      '<p class="stc-print-page-label" data-stc-screen>' +
      screenLabel +
      '</p>' +
      inner +
      '</div>'
    );
  }

  function renderPrintSheet(specs, measuredGap, style, meta, useGapScale) {
    var count = specs.length;
    var labelPaper = meta && meta.printPaper === 'label';
    var infoMain = [];
    infoMain.push('<div class="stc-print-preview__masthead-main">');
    if (!labelPaper) infoMain.push(renderPrintLogo(meta));
    infoMain.push(renderPrintHowto(count, labelPaper, useGapScale));
    if (meta.setupSummary) {
      infoMain.push(meta.setupSummary);
    }
    infoMain.push('</div>');

    if (labelPaper) {
      var infoPage =
        '<div class="stc-print-preview__masthead" data-stc-print-block="masthead">' +
        infoMain.join('') +
        '</div>' +
        '<div class="stc-print-meta-row">' +
        '<div class="stc-print-qr-stack">' +
        renderPrintQrBlock(meta) +
        renderPrintLogo(meta) +
        '</div>' +
        '<div class="stc-calc__print-footer" data-stc-print-block="footer">' +
        renderPrintScaleBar() +
        '</div></div>';
      return (
        renderPrintPage('info', 'Page 1 of 2 · setup, QR &amp; scale', infoPage) +
        renderPrintPage(
          'tapes',
          'Page 2 of 2 · tapes',
          renderPrintTapesBlock(specs, measuredGap, style, useGapScale)
        )
      );
    }

    var parts = [];
    parts.push('<div class="stc-print-preview__masthead" data-stc-print-block="masthead">');
    parts.push(infoMain.join(''));
    parts.push(renderPrintQrBlock(meta));
    parts.push('</div>');
    parts.push(renderPrintTapesBlock(specs, measuredGap, style, useGapScale));
    parts.push('<div class="stc-calc__print-footer" data-stc-print-block="footer">');
    parts.push(renderPrintScaleBar());
    parts.push('</div>');
    return parts.join('');
  }

  function mountPrintQr(container, url) {
    if (!container || !url) return;
    var el = container.querySelector('[data-stc-print-qr]');
    if (!el) return;
    el.innerHTML = '';
    var size = 192;
    if (typeof QRCode === 'undefined') return;
    var level =
      QRCode.CorrectLevel && QRCode.CorrectLevel.L != null ? QRCode.CorrectLevel.L : 1;
    try {
      new QRCode(el, {
        text: url,
        width: size,
        height: size,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: level,
      });
    } catch (e) {
      el.innerHTML = '';
      try {
        new QRCode(el, {
          text: url,
          width: size,
          height: size,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: level,
        });
      } catch (e2) {
        return;
      }
    }
    var svg = el.querySelector('svg');
    if (svg) {
      svg.setAttribute('width', String(size));
      svg.setAttribute('height', String(size));
      svg.style.width = size + 'px';
      svg.style.height = size + 'px';
      svg.style.display = 'block';
    }
    var canvas = el.querySelector('canvas');
    var img = el.querySelector('img');
    if (img && img.src && img.src.indexOf('data:') === 0) {
      img.style.display = 'block';
      img.style.width = size + 'px';
      img.style.height = size + 'px';
      if (canvas) canvas.style.display = 'none';
    } else if (canvas) {
      canvas.style.display = 'block';
      canvas.style.width = size + 'px';
      canvas.style.height = size + 'px';
      if (img) img.style.display = 'none';
    }
  }

  var PRINT_PORTRAIT_TAPE_MAX = 8.75;
  var PRINT_LABEL_TAPE_MAX = 5.6;
  var PRINT_LABEL_ROW_MAX = 3.6;

  function printFitMessage(tapeLenIn, tapeCount, printPaper, opts) {
    opts = opts || {};
    if (tapeLenIn == null || !isFinite(tapeLenIn)) {
      return { text: 'Print at 100% scale. Use the 2×2 in square to verify X and Y.', warn: false };
    }
    var len = fmt(tapeLenIn, 2);
    var scaledNote = opts.scaledToGap ? ' (scaled to your 20–60 gap)' : '';
    var nativeNote =
      opts.nativeFamily && !opts.scaledToGap
        ? ' (native spacing — pick the fps whose 20–60 gap matches, then print 1 scaled tape)'
        : '';
    var note = scaledNote || nativeNote;
    var count = tapeCount > 0 ? tapeCount : 1;
    if (printPaper === 'label') {
      var tapeW = opts.printWidthIn != null && opts.printWidthIn > 0 ? opts.printWidthIn : DEFAULT_TAPE_WIDTH;
      var rowW = count * tapeW + Math.max(0, count - 1) * 0.1;
      if (tapeLenIn > PRINT_LABEL_TAPE_MAX || rowW > PRINT_LABEL_ROW_MAX) {
        return {
          text:
            '4×6 — tape ~' +
            len +
            '"' +
            note +
            ' may not fit the tape label. Shorten the yardage range, print fewer tapes, or use Letter.',
          warn: true,
        };
      }
      return {
        text:
          '4×6 — two labels (setup, then tapes). Tape ~' +
          len +
          '"' +
          note +
          '. In the print dialog pick 4×6 / 100×150 mm at 100%.',
        warn: false,
      };
    }
    if (tapeLenIn > PRINT_PORTRAIT_TAPE_MAX) {
      return {
        text:
          'Tape ~' +
          len +
          '"' +
          note +
          ' may not fit one letter page — shorten the yardage range or reduce tape count.',
        warn: true,
      };
    }
    return {
      text: 'Letter — tape ~' + len + '"' + note + ' should fit one page. Print at 100%.',
      warn: false,
    };
  }

  function applyPrintClasses(paper) {
    var html = document.documentElement;
    html.classList.remove('stc-print-paper-portrait', 'stc-print-paper-landscape', 'stc-print-paper-label');
    html.classList.add(paper === 'label' ? 'stc-print-paper-label' : 'stc-print-paper-portrait');
  }

  function clearPrintClasses() {
    var html = document.documentElement;
    html.classList.remove(
      'stc-print-active',
      'stc-print-paper-portrait',
      'stc-print-paper-landscape',
      'stc-print-paper-label'
    );
  }

  function mountPrintPreview(printPreview, anchor) {
    if (!printPreview || printPreview.parentNode === document.body) return;
    document.body.appendChild(printPreview);
  }

  function restorePrintPreview(printPreview, anchor, fallbackParent) {
    if (!printPreview || printPreview.parentNode !== document.body) return;
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(printPreview, anchor);
      return;
    }
    if (fallbackParent) fallbackParent.appendChild(printPreview);
  }

  function runPrint(printPreview, anchor, fallbackParent, recalcFn) {
    if (!printPreview) {
      window.print();
      return;
    }
    var modalWasOpen = !printPreview.hidden;
    mountPrintPreview(printPreview, anchor);
    printPreview.hidden = false;
    document.documentElement.classList.add('stc-print-active');
    if (typeof recalcFn === 'function') recalcFn();

    var cleaned = false;
    function cleanup() {
      if (cleaned) return;
      cleaned = true;
      clearPrintClasses();
      if (!modalWasOpen) {
        printPreview.hidden = true;
        restorePrintPreview(printPreview, anchor, fallbackParent);
        document.documentElement.style.overflow = '';
      } else {
        document.documentElement.style.overflow = 'hidden';
      }
    }

    window.addEventListener('afterprint', cleanup, { once: true });
    setTimeout(cleanup, 1500);
    window.print();
  }

  function dumpConsole(state) {
    console.group('[Sight tape] ' + (state.fps != null ? state.fps + ' fps' : 'no fps'));
    console.log('Inputs', {
      fps: state.fps,
      measuredGap2060: state.measuredGap,
      hasGap: state.hasGap,
      printScale: state.printScale,
      startYd: state.startYd,
      endYd: state.endYd,
      tapeCount: state.printSpecs ? state.printSpecs.length : 0,
      balOpts: state.balOpts,
    });
    if (state.measurements) {
      console.log('Tape measurements (inches)', state.measurements);
    }
    console.groupEnd();
  }

  function init(root) {
    if (root.getAttribute('data-stc-ready')) return;
    root.setAttribute('data-stc-ready', '1');

    var fpsEl = root.querySelector('[data-stc-fps]');
    var fpsNumEl = root.querySelector('[data-stc-fps-num]');
    var grainsEl = root.querySelector('[data-stc-grains]');
    var grainsNumEl = root.querySelector('[data-stc-grains-num]');
    var gapEl = root.querySelector('[data-stc-gap]');
    var measuredSpanEl = root.querySelector('[data-stc-measured-span]');
    var sightSelectEl = root.querySelector('[data-stc-sight]');
    var peepToSightEl = root.querySelector('[data-stc-peep-to-sight]');
    var peepHeightEl = root.querySelector('[data-stc-peep-height]');
    var densityAltEl = root.querySelector('[data-stc-density-alt]');
    var peepToSightLabelEl = root.querySelector('[data-stc-peep-to-sight-label]');
    var peepHeightLabelEl = root.querySelector('[data-stc-peep-height-label]');
    var peepBowPresetEl = root.querySelector('[data-stc-peep-bow-preset]');
    var peepAtBraceEl = root.querySelector('[data-stc-peep-at-brace]');
    var peepDrawLengthEl = root.querySelector('[data-stc-peep-draw-length]');
    var peepAtaEl = root.querySelector('[data-stc-peep-ata]');
    var peepBraceEl = root.querySelector('[data-stc-peep-brace]');
    var peepEstimateEl = root.querySelector('[data-stc-peep-estimate]');
    var peepApplyBtn = root.querySelector('[data-stc-peep-apply]');
    var peepCustomGeomEls = root.querySelectorAll('[data-stc-peep-custom-geom] input');
    var sightUnitsBtns = root.querySelectorAll('[data-stc-sight-units]');
    var startEl = root.querySelector('[data-stc-start]');
    var endEl = root.querySelector('[data-stc-end]');
    var chipFps = root.querySelector('[data-stc-chip-fps]');
    var chipGrains = root.querySelector('[data-stc-chip-grains]');
    var rangeChip = root.querySelector('[data-stc-range-chip]');
    var previewEl = root.querySelector('[data-stc-preview]');
    var gapNote = root.querySelector('[data-stc-gap-note]');
    var tapeCountHintEl = root.querySelector('[data-stc-tape-count-hint]');
    var previewCountEl = root.querySelector('[data-stc-preview-count]');
    var printPreview = root.querySelector('[data-stc-print-preview]');
    var printPreviewAnchor = document.createComment('stc-print-preview-anchor');
    if (printPreview && printPreview.parentNode) {
      printPreview.parentNode.insertBefore(printPreviewAnchor, printPreview);
    }
    function printSheetEl() {
      return printPreview
        ? printPreview.querySelector('[data-stc-print]')
        : root.querySelector('[data-stc-print]');
    }
    function openPrintPreviewModal() {
      mountPrintPreview(printPreview, printPreviewAnchor);
      printPreview.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      recalc();
    }
    function closePrintPreviewModal() {
      if (!printPreview) return;
      printPreview.hidden = true;
      document.documentElement.style.overflow = '';
      restorePrintPreview(printPreview, printPreviewAnchor, root);
    }
    var printBtn = root.querySelector('[data-stc-print-btn]');
    var printLoadingBtn = root.querySelector('[data-stc-print-loading]');
    var previewLayoutBtn = root.querySelector('[data-stc-preview-layout]');
    var signInPrint = root.querySelector('[data-stc-sign-in-print]');
    var doPrintBtn = root.querySelector('[data-stc-do-print]');
    var closePreviewBtn = root.querySelector('[data-stc-close-preview]');
    var printPaperBtns = root.querySelectorAll('[data-stc-print-paper]');
    var tapeCountBtns = root.querySelectorAll('[data-stc-tape-count]');
    var tapeModeBtns = root.querySelectorAll('[data-stc-tape-mode]');
    var printFitEl = root.querySelector('[data-stc-print-fit]');
    var measureEl = root.querySelector('[data-stc-measure]');
    var bgEl = root.querySelector('[data-stc-color-bg]');
    var textEl = root.querySelector('[data-stc-color-text]');
    var tickEl = root.querySelector('[data-stc-color-tick]');
    var tickFiveEl = root.querySelector('[data-stc-color-tick-five]');
    var textFiveEl = root.querySelector('[data-stc-color-text-five]');
    var fiveTickColorBtns = root.querySelectorAll('[data-stc-five-tick-color]');
    var fiveLabelColorBtns = root.querySelectorAll('[data-stc-five-label-color]');
    var alignBtns = root.querySelectorAll('[data-stc-align]');
    var tickAlignBtns = root.querySelectorAll('[data-stc-tick-align]');
    var subTickAlignBtns = root.querySelectorAll('[data-stc-sub-tick-align]');
    var labelStepBtns = root.querySelectorAll('[data-stc-label-step]');
    var splitLabelBtns = root.querySelectorAll('[data-stc-split-labels]');
    var alignWrap = root.querySelector('[data-stc-align-wrap]');
    var printWidthEl = root.querySelector('[data-stc-print-width]');
    var tapeWidthEl = root.querySelector('[data-stc-tape-width]');
    var printStartOffsetEl = root.querySelector('[data-stc-print-start-offset]');
    var printMaxHeightEl = root.querySelector('[data-stc-print-max-height]');
    var printEccPromisedEl = root.querySelector('[data-stc-print-ecc-promised]');
    var printEccActualEl = root.querySelector('[data-stc-print-ecc-actual]');
    var tickBtns = root.querySelectorAll('[data-stc-tick-step]');
    var tipBtns = root.querySelectorAll('[data-stc-tip]');
    var labelOffsetEl = root.querySelector('[data-stc-label-offset]');
    var labelSizeEl = root.querySelector('[data-stc-label-size]');
    var tickWidthEl = root.querySelector('[data-stc-tick-width]');
    var chipLabelOffset = root.querySelector('[data-stc-chip-label-offset]');
    var chipLabelSize = root.querySelector('[data-stc-chip-label-size]');
    var chipTapeWidth = root.querySelector('[data-stc-chip-tape-width]');
    var chipTickWidth = root.querySelector('[data-stc-chip-tick-width]');
    var align = 'right';
    var tip = 'field';
    var tickAlign = 'left';
    var subTickAlign = 'center';
    var labelStep = 10;
    var splitLabels = false;
    var labelOffsetPx = 0;
    var labelSizePct = 100;
    var tickWidthPct = DEFAULT_TICK_WIDTH_PCT;
    var tickStep = 2;
    var fiveTickColorOn = false;
    var fiveLabelColorOn = false;
    var printPaper = 'portrait';
    var tapeCount = 5;
    var tapeMode = 'offset';
    var sightUnits = 'in';
    var dumpTimer = null;
    var lastState = null;

    var presets = window.TitleXCalcPresets;
    if (presets && !presets.hasUrlOverride('fps')) presets.apply('sight-tape', root);

    var calcTools = window.TitleXCalcTools;
    if (calcTools && calcTools.wirePresetPrompt) {
      calcTools.wirePresetPrompt('sight-tape', root, {
        getExtras: function () {
          return { fps: num(fpsEl) };
        },
      });
    }

    var pressedAlign = root.querySelector('[data-stc-align][aria-pressed="true"]');
    if (pressedAlign) align = pressedAlign.getAttribute('data-stc-align') || 'center';
    var pressedTip = root.querySelector('[data-stc-tip][aria-pressed="true"]');
    if (pressedTip) tip = pressedTip.getAttribute('data-stc-tip') === 'fixed' ? 'fixed' : 'field';
    var pressedTickAlign = root.querySelector('[data-stc-tick-align][aria-pressed="true"]');
    if (pressedTickAlign) tickAlign = pressedTickAlign.getAttribute('data-stc-tick-align') || 'center';
    var pressedSubTickAlign = root.querySelector('[data-stc-sub-tick-align][aria-pressed="true"]');
    if (pressedSubTickAlign) {
      subTickAlign = pressedSubTickAlign.getAttribute('data-stc-sub-tick-align') || 'center';
    }
    var pressedLabelStep = root.querySelector('[data-stc-label-step][aria-pressed="true"]');
    if (pressedLabelStep) {
      var ls = parseInt(pressedLabelStep.getAttribute('data-stc-label-step'), 10);
      labelStep = ls === 5 ? 5 : 10;
    }
    var pressedSplitLabels = root.querySelector('[data-stc-split-labels][aria-pressed="true"]');
    if (pressedSplitLabels) {
      splitLabels = pressedSplitLabels.getAttribute('data-stc-split-labels') === 'on';
    }
    var pressedTick = root.querySelector('[data-stc-tick-step][aria-pressed="true"]');
    if (pressedTick) {
      var step = parseInt(pressedTick.getAttribute('data-stc-tick-step'), 10);
      if (isFinite(step)) tickStep = step;
    }
    if (labelOffsetEl) {
      var lo = parseInt(labelOffsetEl.value, 10);
      if (isFinite(lo)) labelOffsetPx = clamp(lo, LABEL_OFFSET_MIN, LABEL_OFFSET_MAX);
    }
    if (labelSizeEl) {
      var ls = parseInt(labelSizeEl.value, 10);
      if (isFinite(ls)) labelSizePct = clamp(ls, LABEL_SIZE_PCT_MIN, LABEL_SIZE_PCT_MAX);
    }
    if (tickWidthEl) {
      var tw = parseInt(tickWidthEl.value, 10);
      if (isFinite(tw)) tickWidthPct = resolveTickWidthPct(tw);
    }
    var pressedTapeCount = root.querySelector('[data-stc-tape-count][aria-pressed="true"]');
    if (pressedTapeCount) {
      var tc = parseInt(pressedTapeCount.getAttribute('data-stc-tape-count'), 10);
      if (isFinite(tc)) tapeCount = tc;
    }
    var pressedTapeMode = root.querySelector('[data-stc-tape-mode][aria-pressed="true"]');
    if (pressedTapeMode) tapeMode = pressedTapeMode.getAttribute('data-stc-tape-mode') || 'offset';
    var pressedFiveTickColor = root.querySelector('[data-stc-five-tick-color][aria-pressed="true"]');
    if (pressedFiveTickColor) {
      fiveTickColorOn = pressedFiveTickColor.getAttribute('data-stc-five-tick-color') === 'on';
    }
    var pressedFiveLabelColor = root.querySelector('[data-stc-five-label-color][aria-pressed="true"]');
    if (pressedFiveLabelColor) {
      fiveLabelColorOn = pressedFiveLabelColor.getAttribute('data-stc-five-label-color') === 'on';
    }

    function syncFiveTickColorUi() {
      if (tickFiveEl) tickFiveEl.disabled = !fiveTickColorOn;
    }

    function syncFiveLabelColorUi() {
      var available = labelStep === 5;
      var wrap = root.querySelector('[data-stc-five-label-color-wrap]');
      if (wrap) wrap.classList.toggle('stc-calc__choice--inactive', !available);
      fiveLabelColorBtns.forEach(function (btn) {
        btn.disabled = !available;
      });
      if (textFiveEl) textFiveEl.disabled = !(available && fiveLabelColorOn);
    }

    function syncTapeWidthFromSlider() {
      var v = num(tapeWidthEl);
      if (v == null) return;
      v = clamp(v, TAPE_WIDTH_MIN, TAPE_WIDTH_MAX);
      if (printWidthEl) printWidthEl.value = fmt(v, 2);
    }

    function syncTapeWidthFromNum() {
      var v = num(printWidthEl);
      if (v == null || !tapeWidthEl) return;
      tapeWidthEl.value = String(clamp(v, TAPE_WIDTH_MIN, TAPE_WIDTH_MAX));
    }

    function syncTapeWidthChip(widthIn) {
      setChip(chipTapeWidth, fmt(widthIn, 2) + '"');
      if (tapeWidthEl) setFill(tapeWidthEl);
    }

    function readTapeWidthIn() {
      var v = num(tapeWidthEl);
      if (v == null) v = num(printWidthEl);
      if (v == null || v <= 0) return DEFAULT_TAPE_WIDTH;
      return clamp(v, TAPE_WIDTH_MIN, TAPE_WIDTH_MAX);
    }

    function formatLabelOffset(n) {
      if (n === 0) return 'On tick line';
      return (n > 0 ? '+' : '') + n + ' px';
    }

    function syncLabelOffsetChip() {
      setChip(chipLabelOffset, formatLabelOffset(labelOffsetPx));
      if (labelOffsetEl) setFill(labelOffsetEl);
    }

    function syncLabelSizeChip(style) {
      if (!chipLabelSize) return;
      var scale = resolveLabelScale(
        {
          tapeW: previewTapeW(style.printWidthIn),
          sidePad: 10,
          splitLabels: splitLabels,
          tickAlign: tickAlign,
          endYd: style.endYd,
          labelSizePct: labelSizePct,
          tickWidthPct: tickWidthPct,
          printWidthIn: style.printWidthIn,
        },
        'preview'
      );
      setChip(chipLabelSize, Math.round(scale * 100) + '% of default');
      if (labelSizeEl) setFill(labelSizeEl);
    }

    function syncTickWidthChip() {
      setChip(chipTickWidth, Math.round(tickWidthPct) + '% across');
      if (tickWidthEl) setFill(tickWidthEl);
    }

    var urlFps = fpsFromUrl();
    if (urlFps != null) {
      if (fpsEl) fpsEl.value = String(Math.round(urlFps));
      if (fpsNumEl) fpsNumEl.value = String(Math.round(urlFps));
    }

    function scheduleDump(state) {
      clearTimeout(dumpTimer);
      dumpTimer = setTimeout(function () {
        dumpConsole(state);
      }, DUMP_MS);
    }

    function syncFpsFromSlider() {
      var T = window.TitleXCalcTools;
      if (T && T.syncNumFromSlider) T.syncNumFromSlider(fpsEl, fpsNumEl, Math.round);
      else if (fpsNumEl && num(fpsEl) != null) fpsNumEl.value = String(Math.round(num(fpsEl)));
    }

    function syncFpsFromNum() {
      var T = window.TitleXCalcTools;
      if (T && T.syncSliderFromNum) T.syncSliderFromNum(fpsNumEl, fpsEl, FPS_MIN, FPS_MAX, Math.round);
      else {
        var v = num(fpsNumEl);
        if (v != null && fpsEl) fpsEl.value = String(clamp(v, FPS_MIN, FPS_MAX));
      }
    }

    function syncGrainsFromSlider() {
      var T = window.TitleXCalcTools;
      if (T && T.syncNumFromSlider) T.syncNumFromSlider(grainsEl, grainsNumEl, Math.round);
      else if (grainsNumEl && num(grainsEl) != null) grainsNumEl.value = String(Math.round(num(grainsEl)));
    }

    function syncGrainsFromNum() {
      var T = window.TitleXCalcTools;
      if (T && T.syncSliderFromNum) T.syncSliderFromNum(grainsNumEl, grainsEl, GRAINS_MIN, GRAINS_MAX, Math.round);
      else {
        var v = num(grainsNumEl);
        if (v != null && grainsEl) grainsEl.value = String(clamp(v, GRAINS_MIN, GRAINS_MAX));
      }
    }

    function readFpsForCalc() {
      var T = window.TitleXCalcTools;
      if (fpsNumEl && document.activeElement === fpsNumEl && T && T.parseInputNum) {
        var raw = T.parseInputNum(fpsNumEl);
        if (raw == null) return clamp(num(fpsEl), FPS_MIN, FPS_MAX);
        if (raw >= FPS_MIN && raw <= FPS_MAX) return Math.round(raw);
        return clamp(num(fpsEl), FPS_MIN, FPS_MAX);
      }
      var v =
        T && T.readPairedInput
          ? T.readPairedInput(fpsEl, fpsNumEl, FPS_MIN, FPS_MAX)
          : clamp(num(fpsEl), FPS_MIN, FPS_MAX);
      return v != null ? Math.round(v) : null;
    }

    function readGrainsForCalc() {
      var T = window.TitleXCalcTools;
      if (grainsNumEl && document.activeElement === grainsNumEl && T && T.parseInputNum) {
        var raw = T.parseInputNum(grainsNumEl);
        if (raw == null) return clamp(num(grainsEl), GRAINS_MIN, GRAINS_MAX);
        if (raw >= GRAINS_MIN && raw <= GRAINS_MAX) return Math.round(raw);
        return clamp(num(grainsEl), GRAINS_MIN, GRAINS_MAX);
      }
      var v =
        T && T.readPairedInput
          ? T.readPairedInput(grainsEl, grainsNumEl, GRAINS_MIN, GRAINS_MAX)
          : clamp(num(grainsEl), GRAINS_MIN, GRAINS_MAX);
      return v != null ? Math.round(v) : null;
    }

    function currentStyle() {
      var startYd = snapYard(num(startEl)) || 20;
      var endYd = snapYard(num(endEl)) || 80;
      if (endYd <= startYd) endYd = Math.min(YARD_MAX, startYd + YARD_STEP);
      var printWidthIn = readTapeWidthIn();
      var printStartOffset = num(printStartOffsetEl);
      var printMaxHeight = num(printMaxHeightEl);
      var grains = readGrainsForCalc();
      grains = grains != null ? clamp(grains, GRAINS_MIN, GRAINS_MAX) : null;
      var unitsBtn = root.querySelector('[data-stc-sight-units][aria-pressed="true"]');
      var sightUnitsVal =
        unitsBtn && unitsBtn.getAttribute('data-stc-sight-units') === 'mm' ? 'mm' : 'in';
      var style = {
        startYd: startYd,
        endYd: endYd,
        grains: grains != null ? grains : DEFAULT_GRAINS,
        tip: tip,
        tick: (tickEl && tickEl.value) || DEFAULT_TICK,
        tickFive: (tickFiveEl && tickFiveEl.value) || DEFAULT_TICK_FIVE,
        fiveTickColorOn: fiveTickColorOn,
        fiveLabelColorOn: fiveLabelColorOn,
        bg: (bgEl && bgEl.value) || DEFAULT_BG,
        text: (textEl && textEl.value) || DEFAULT_TEXT,
        textFive: (textFiveEl && textFiveEl.value) || DEFAULT_TEXT_FIVE,
        align: align,
        tickAlign: tickAlign,
        subTickAlign: subTickAlign,
        labelStep: labelStep,
        splitLabels: splitLabels,
        labelOffsetPx: labelOffsetPx,
        labelSizePct: labelSizePct,
        tickWidthPct: tickWidthPct,
        tickStep: tickStep,
        printWidthIn: printWidthIn,
        printStartOffset: printStartOffset != null && printStartOffset >= 0 ? printStartOffset : 0.07,
        printMaxHeight: printMaxHeight != null && printMaxHeight > 0 ? printMaxHeight : null,
        printEcc: printEccFactor(num(printEccPromisedEl), num(printEccActualEl)),
        peepToSight: num(peepToSightEl),
        peepHeight: num(peepHeightEl),
        sightId: sightSelectEl ? sightSelectEl.value : 'printed',
        sightUnits: sightUnitsVal,
        densityAltFt: num(densityAltEl),
        measuredSpan: num(measuredSpanEl),
      };
      style.sightOpts = sightOptsFromStyle(style);
      return style;
    }

    function needsAccountLogin() {
      var Lib = window.TitleXSightTapeLibrary;
      var cfg = Lib ? Lib.accountConfig(root) : { accountsEnabled: false, loggedIn: true };
      return cfg.accountsEnabled && !cfg.loggedIn;
    }

    function effectiveTapeCount() {
      return needsAccountLogin() ? 1 : tapeCount;
    }

    function recalc() {
      if (labelOffsetEl) {
        var lo = parseInt(labelOffsetEl.value, 10);
        if (isFinite(lo)) labelOffsetPx = clamp(lo, LABEL_OFFSET_MIN, LABEL_OFFSET_MAX);
      }
      if (labelSizeEl) {
        var lsp = parseInt(labelSizeEl.value, 10);
        if (isFinite(lsp)) labelSizePct = clamp(lsp, LABEL_SIZE_PCT_MIN, LABEL_SIZE_PCT_MAX);
      }
      if (tickWidthEl) {
        var twr = parseInt(tickWidthEl.value, 10);
        if (isFinite(twr)) tickWidthPct = resolveTickWidthPct(twr);
      }
      var fps = readFpsForCalc();
      fps = fps != null ? clamp(fps, FPS_MIN, FPS_MAX) : null;
      var measuredGap = num(gapEl);
      var measuredSpan = num(measuredSpanEl);
      var hasGap = measuredGap != null && measuredGap > 0;
      var style = currentStyle();
      var roundedFps = fps != null ? Math.round(fps) : null;
      var countForPreview = effectiveTapeCount();
      var specs = roundedFps != null ? buildTapeSpecs(roundedFps, countForPreview, tapeMode) : [];
      var printScale = shouldScalePrint(hasGap);

      setFill(fpsEl);
      if (grainsEl) setFill(grainsEl);
      setChip(chipFps, fps != null ? Math.round(fps) + ' fps' : '—');
      setChip(chipGrains, balOptsLabel(balOptsFromStyle(style)));
      syncLabelOffsetChip();
      syncLabelSizeChip(style);
      syncTapeWidthChip(style.printWidthIn);
      syncTickWidthChip();

      if (tapeCountHintEl) {
        if (needsAccountLogin()) {
          tapeCountHintEl.textContent =
            'Preview: 1 tape · create a free account to choose multiple tapes and print.';
        } else {
          tapeCountHintEl.textContent =
            'Preview & print: ' +
            specs.length +
            (specs.length === 1 ? ' tape' : ' tapes') +
            (printScale ? ' (scaled to gap)' : '') +
            ' · check the 2×2 in square at 100%.';
        }
      }

      if (fps == null) {
        if (previewEl) previewEl.innerHTML = '';
        var emptySheet = printSheetEl();
        if (emptySheet) emptySheet.innerHTML = '';
        if (measureEl) measureEl.innerHTML = '';
        lastState = null;
        return;
      }

      var primaryTape = buildTape(
        roundedFps,
        style.endYd,
        style.startYd,
        balOptsFromStyle(style),
        style.sightOpts
      );
      var balOpts = balOptsFromStyle(style);
      var lengthResolved = resolveLengthScale(primaryTape, {
        measuredGap: measuredGap,
      });
      var lengthScale = !printScale ? 1 : lengthResolved.scale;
      var lengthEcc = printScale ? style.printEcc || 1 : 1;
      style.measuredGap = measuredGap;
      style.measuredSpan = measuredSpan;
      style.centerFps = roundedFps;
      style.lengthScale = lengthScale;
      var markShape = printScale
        ? markShapeForTape(primaryTape, measuredGap, measuredSpan, style.startYd, style.endYd)
        : null;
      style.markShape = markShape;
      var tapeLen = tapeSpanInches(
        primaryTape,
        lengthScale,
        style.startYd,
        style.endYd,
        lengthEcc,
        markShape
      );
      var measurements = tapeMeasureSummary(primaryTape, {
        startYd: style.startYd,
        endYd: style.endYd,
        measuredGap: measuredGap,
        measuredSpan: measuredSpan,
        printScale: printScale,
        printEcc: style.printEcc || 1,
        printStartOffset: style.printStartOffset,
        markShape: markShape,
        sightPeepToSight: style.sightOpts.peepToSight,
        sightPeepHeight: style.sightOpts.peepHeight,
        sightLabel:
          sightSelectEl && sightSelectEl.selectedIndex >= 0
            ? sightSelectEl.options[sightSelectEl.selectedIndex].text
            : '',
        densityAltFt: style.densityAltFt,
        labelScale: resolveLabelScale(
          {
            tapeW: style.printWidthIn,
            sidePad: 0.08,
            splitLabels: splitLabels,
            tickAlign: tickAlign,
            endYd: style.endYd,
            labelSizePct: labelSizePct,
            tickWidthPct: tickWidthPct,
            printWidthIn: style.printWidthIn,
          },
          'print'
        ),
      });
      if (measureEl) {
        measureEl.innerHTML = renderMeasureSummary(measurements);
      }
      if (gapNote) {
        gapNote.classList.remove('is-warn');
        if (hasGap && printScale && markShape) {
          gapNote.textContent =
            '20–60 stays at ' +
            fmt(measuredGap, 3) +
            '". Marks past 60 are stretched so this yardage is ' +
            fmt(measuredSpan, 3) +
            '" tick to tick. Preview matches print.';
        } else if (hasGap && printScale) {
          gapNote.textContent =
            'Print scales to your ' +
            fmt(measuredGap, 2) +
            '" 20–60 gap using chrono speed and arrow weight. Preview matches print.';
        } else if (hasGap) {
          gapNote.textContent =
            'Gap field set — printing ' +
            countForPreview +
            ' native-spacing tape' +
            (countForPreview === 1 ? '' : 's') +
            ' so you can pick the best fps, then clear and print one scaled tape.';
        } else if (tapeMode === 'same') {
          gapNote.textContent =
            'Printing ' +
            countForPreview +
            ' cop' +
            (countForPreview === 1 ? 'y' : 'ies') +
            ' at ' +
            roundedFps +
            ' fps. Enter a measured gap to scale to your sight.';
        } else {
          gapNote.textContent =
            countForPreview +
            ' tape' +
            (countForPreview === 1 ? '' : 's') +
            ' in 1 fps steps centered on your speed — pick the one whose 20–60 gap matches your sight.';
        }
      }
      setChip(
        rangeChip,
        style.startYd +
          '–' +
          style.endYd +
          ' yd · ' +
          balOptsLabel(balOpts) +
          ' · ~' +
          fmt(tapeLen, 2) +
          '"' +
          (printScale ? ' scaled' : hasGap ? ' native' : '') +
          (lengthEcc !== 1 && printScale ? ' · print corr ' + fmt(lengthEcc, 3) + '×' : '') +
          ' · tick every ' +
          tickStep +
          ' yd' +
          (tickStep > 1 ? ' + 1 yd' : '') +
          ' · labels every ' +
          (labelStep === 5 ? '5 yd' : '10 yd') +
          (splitLabels
            ? labelStep === 5
              ? ' · split 10s R / 5s L'
              : ' · split even/odd 10s'
            : '')
      );
      if (printFitEl) {
        var fit = printFitMessage(tapeLen, specs.length, printPaper, {
          scaledToGap: printScale,
          nativeFamily: hasGap && !printScale,
          printWidthIn: style.printWidthIn,
        });
        printFitEl.textContent = fit.text;
        printFitEl.classList.toggle('is-warn', !!fit.warn);
      }
      if (previewEl) {
        previewEl.innerHTML = renderLivePreview(specs, style, lengthScale, lengthEcc);
      }
      var printEl = printSheetEl();
      if (printEl) {
        var LibShare = window.TitleXSightTapeLibrary;
        var shareSnapshot = LibShare ? LibShare.collectSnapshot(root) : null;
        var shareBase = printPreview ? printPreview.getAttribute('data-stc-share-base') || '' : '';
        var shareUrl =
          LibShare && shareSnapshot
            ? LibShare.buildShareUrl(shareSnapshot, { forPrint: true, baseUrl: shareBase })
            : '';
        var bowName =
          (shareSnapshot && shareSnapshot.bowName) ||
          (function () {
            var activeProfile = root.querySelector('[data-stc-lib-profiles] [aria-pressed="true"]');
            return activeProfile ? activeProfile.textContent.trim() : '';
          })();
        printEl.innerHTML = renderPrintSheet(
          specs,
          measuredGap,
          style,
          {
            logo: printPreview ? printPreview.getAttribute('data-stc-logo') || '' : '',
            shop: printPreview ? printPreview.getAttribute('data-stc-shop') || 'TitleX Archery' : 'TitleX Archery',
            setupSummary: renderPrintSetupSummary(roundedFps, style, measurements),
            shareUrl: shareUrl,
            bowName: bowName,
            printPaper: printPaper,
          },
          printScale
        );
        mountPrintQr(printEl, shareUrl);
      }
      if (previewCountEl) {
        previewCountEl.textContent =
          'Print preview · ' +
          specs.length +
          (specs.length === 1 ? ' tape' : ' tapes') +
          (printScale ? ' · scaled' : ' · native spacing') +
          (printPaper === 'label' ? ' · 4×6 · 2 pages' : '');
      }

      lastState = {
        fps: roundedFps,
        measuredGap: measuredGap,
        measuredSpan: measuredSpan,
        hasGap: hasGap,
        hasReferenceSpan: measuredSpan != null && measuredSpan > 0,
        tapeCount: tapeCount,
        tapeMode: tapeMode,
        printScale: printScale,
        startYd: style.startYd,
        endYd: style.endYd,
        previewSpecs: specs,
        printSpecs: specs,
        measurements: measurements,
        balOpts: balOpts,
      };
      scheduleDump(lastState);
    }

    function setTapeCount(next) {
      if (needsAccountLogin()) {
        requirePrintAccess();
        return;
      }
      tapeCount = clamp(next, 1, 9) || 5;
      tapeCountBtns.forEach(function (btn) {
        btn.setAttribute(
          'aria-pressed',
          String(btn.getAttribute('data-stc-tape-count')) === String(tapeCount) ? 'true' : 'false'
        );
      });
      recalc();
    }

    function setTapeMode(next) {
      tapeMode = next === 'same' ? 'same' : 'offset';
      tapeModeBtns.forEach(function (btn) {
        btn.setAttribute(
          'aria-pressed',
          btn.getAttribute('data-stc-tape-mode') === tapeMode ? 'true' : 'false'
        );
      });
      recalc();
    }

    function setSplitLabels(on) {
      splitLabels = on !== false;
      splitLabelBtns.forEach(function (btn) {
        var isOn = btn.getAttribute('data-stc-split-labels') === 'on';
        btn.setAttribute('aria-pressed', isOn === splitLabels ? 'true' : 'false');
      });
      syncSplitLabelControls();
      recalc();
    }

    function syncSplitLabelControls() {
      if (alignWrap) alignWrap.hidden = splitLabels;
    }

    function setLabelStep(next) {
      labelStep = next === 5 ? 5 : 10;
      labelStepBtns.forEach(function (btn) {
        btn.setAttribute(
          'aria-pressed',
          String(btn.getAttribute('data-stc-label-step')) === String(labelStep) ? 'true' : 'false'
        );
      });
      if (labelStep === 5 && !fiveLabelColorOn) {
        fiveLabelColorOn = true;
        fiveLabelColorBtns.forEach(function (btn) {
          btn.setAttribute(
            'aria-pressed',
            btn.getAttribute('data-stc-five-label-color') === 'on' ? 'true' : 'false'
          );
        });
        if (
          textFiveEl &&
          tickFiveEl &&
          String(textFiveEl.value).toLowerCase() === DEFAULT_TEXT_FIVE.toLowerCase()
        ) {
          textFiveEl.value = tickFiveEl.value;
        }
      }
      syncFiveLabelColorUi();
      recalc();
    }

    function setSubTickAlign(next) {
      subTickAlign = next || 'center';
      subTickAlignBtns.forEach(function (btn) {
        btn.setAttribute(
          'aria-pressed',
          btn.getAttribute('data-stc-sub-tick-align') === subTickAlign ? 'true' : 'false'
        );
      });
      recalc();
    }

    function syncSubTickAlignControls() {
      var wrap = root.querySelector('[data-stc-sub-tick-align-wrap]');
      if (!wrap) return;
      wrap.hidden = false;
      wrap.classList.remove('stc-calc__choice--inactive');
      subTickAlignBtns.forEach(function (btn) {
        btn.disabled = false;
      });
      var help = wrap.querySelector('[data-stc-sub-tick-help]');
      if (help) {
        help.textContent =
          tickStep === 1
            ? 'Align short 1 yd marks (non-5 / non-10 yd) left, center, or right on the tape.'
            : 'With 2 yd spacing, align the extra 1 yd marks between 2 yd ticks left, center, or right.';
      }
    }

    function setFiveTickColor(next) {
      fiveTickColorOn = next === 'on';
      fiveTickColorBtns.forEach(function (btn) {
        btn.setAttribute(
          'aria-pressed',
          btn.getAttribute('data-stc-five-tick-color') === (fiveTickColorOn ? 'on' : 'off')
            ? 'true'
            : 'false'
        );
      });
      syncFiveTickColorUi();
      recalc();
    }

    function setFiveLabelColor(next) {
      fiveLabelColorOn = next === 'on';
      fiveLabelColorBtns.forEach(function (btn) {
        btn.setAttribute(
          'aria-pressed',
          btn.getAttribute('data-stc-five-label-color') === (fiveLabelColorOn ? 'on' : 'off')
            ? 'true'
            : 'false'
        );
      });
      syncFiveLabelColorUi();
      recalc();
    }

    function setTickStep(next) {
      tickStep = next === 1 || next === 2 ? next : 2;
      tickBtns.forEach(function (btn) {
        btn.setAttribute(
          'aria-pressed',
          String(btn.getAttribute('data-stc-tick-step')) === String(tickStep) ? 'true' : 'false'
        );
      });
      syncSubTickAlignControls();
      recalc();
    }

    function setSightUnits(next) {
      var target = next === 'mm' ? 'mm' : 'in';
      if (target === sightUnits) return;
      var prev = sightUnits;
      sightUnits = target;
      if (peepToSightEl && peepToSightEl.value !== '') {
        var pts = num(peepToSightEl);
        if (pts != null) peepToSightEl.value = displayFromInches(inchesFromDisplay(pts, prev), sightUnits);
      }
      if (peepHeightEl && peepHeightEl.value !== '') {
        var ph = num(peepHeightEl);
        if (ph != null) peepHeightEl.value = displayFromInches(inchesFromDisplay(ph, prev), sightUnits);
      }
      sightUnitsBtns.forEach(function (btn) {
        btn.setAttribute(
          'aria-pressed',
          btn.getAttribute('data-stc-sight-units') === sightUnits ? 'true' : 'false'
        );
      });
      syncSightUnitLabels();
      updatePeepHeightEstimate();
      recalc();
    }

    function syncSightUnitLabels() {
      var suffix = sightUnits === 'mm' ? ' (mm)' : ' (in)';
      if (peepToSightLabelEl) {
        peepToSightLabelEl.textContent = 'Peep to sight' + suffix;
      }
      if (peepHeightLabelEl) {
        peepHeightLabelEl.textContent = 'Peep height' + suffix;
      }
    }

    function readPeepHelperGeom() {
      var presetId = peepBowPresetEl ? peepBowPresetEl.value : 'mathews-mr6';
      var ata = num(peepAtaEl);
      var bh = num(peepBraceEl);
      if (presetId !== 'custom' && Sights && Sights.bowPresets && Sights.bowPresets[presetId]) {
        var preset = Sights.bowPresets[presetId];
        ata = preset.ataIn;
        bh = preset.braceHeightIn;
        if (peepAtaEl) peepAtaEl.value = String(ata);
        if (peepBraceEl) peepBraceEl.value = String(bh);
      }
      return { ataIn: ata, braceHeightIn: bh };
    }

    function syncPeepBowPresetFields() {
      var custom = peepBowPresetEl && peepBowPresetEl.value === 'custom';
      if (peepCustomGeomEls) {
        peepCustomGeomEls.forEach(function (el) {
          el.disabled = !custom;
        });
      }
      if (!custom) readPeepHelperGeom();
      updatePeepHeightEstimate();
    }

    function estimatePeepHeightFullDraw() {
      if (!Sights || typeof Sights.peepHeightFullDrawIn !== 'function') return null;
      var geom = readPeepHelperGeom();
      return Sights.peepHeightFullDrawIn({
        peepHeightAtBraceIn: num(peepAtBraceEl),
        drawLengthIn: num(peepDrawLengthEl),
        ataIn: geom.ataIn,
        braceHeightIn: geom.braceHeightIn,
      });
    }

    function updatePeepHeightEstimate() {
      if (!peepEstimateEl) return;
      var est = estimatePeepHeightFullDraw();
      if (est == null || !isFinite(est) || est <= 0) {
        peepEstimateEl.textContent = 'Estimated full-draw peep height: —';
        return;
      }
      var display = sightUnits === 'mm' ? displayFromInches(est, 'mm') + ' mm' : fmt(est, 2) + '"';
      peepEstimateEl.textContent =
        'Estimated full-draw peep height: ' +
        display +
        ' (from ' +
        fmt(num(peepAtBraceEl), 2) +
        '" at brace · ' +
        fmt(num(peepDrawLengthEl), 1) +
        '" draw)';
    }

    function applyPeepHeightEstimate() {
      var est = estimatePeepHeightFullDraw();
      if (est == null || !isFinite(est) || est <= 0 || !peepHeightEl) return;
      var clamped = clamp(est, PEEP_HEIGHT_MIN, PEEP_HEIGHT_MAX);
      peepHeightEl.value = displayFromInches(clamped, sightUnits);
      recalc();
    }

    function setTip(next) {
      tip = next === 'fixed' ? 'fixed' : 'field';
      tipBtns.forEach(function (btn) {
        btn.setAttribute(
          'aria-pressed',
          btn.getAttribute('data-stc-tip') === tip ? 'true' : 'false'
        );
      });
      recalc();
    }

    function setAlign(next) {
      align = next;
      alignBtns.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-stc-align') === next ? 'true' : 'false');
      });
      recalc();
    }

    function setTickAlign(next) {
      tickAlign = next;
      tickAlignBtns.forEach(function (btn) {
        btn.setAttribute(
          'aria-pressed',
          btn.getAttribute('data-stc-tick-align') === next ? 'true' : 'false'
        );
      });
      recalc();
    }

    var Sights = window.TitleXSightTapeSights;
    if (Sights && sightSelectEl) Sights.populateSelect(sightSelectEl, 'printed');
    syncSightUnitLabels();
    syncPeepBowPresetFields();

    if (peepBowPresetEl) {
      peepBowPresetEl.addEventListener('change', syncPeepBowPresetFields);
    }
    if (peepApplyBtn) {
      peepApplyBtn.addEventListener('click', applyPeepHeightEstimate);
    }

    var calcTools = window.TitleXCalcTools;
    if (calcTools && calcTools.wireCalcInputs) {
      calcTools.wireCalcInputs(root, {
        recalc: recalc,
        pairs: [
          {
            slider: fpsEl,
            num: fpsNumEl,
            fromSlider: syncFpsFromSlider,
            normalize: syncFpsFromNum,
          },
          {
            slider: grainsEl,
            num: grainsNumEl,
            fromSlider: syncGrainsFromSlider,
            normalize: syncGrainsFromNum,
          },
          {
            slider: tapeWidthEl,
            num: printWidthEl,
            fromSlider: syncTapeWidthFromSlider,
            normalize: function () {
              syncTapeWidthFromNum();
              syncTapeWidthFromSlider();
            },
          },
        ],
        onInput: function (e, scheduleRecalc) {
          if (
            e.target === peepAtBraceEl ||
            e.target === peepDrawLengthEl ||
            e.target === peepAtaEl ||
            e.target === peepBraceEl
          ) {
            updatePeepHeightEstimate();
          }
          scheduleRecalc();
        },
      });
    } else {
      root.addEventListener('input', function (e) {
        if (e.target === fpsNumEl) syncFpsFromNum();
        if (e.target === grainsNumEl) syncGrainsFromNum();
        if (e.target === tapeWidthEl) syncTapeWidthFromSlider();
        if (e.target === printWidthEl) syncTapeWidthFromNum();
        if (
          e.target === peepAtBraceEl ||
          e.target === peepDrawLengthEl ||
          e.target === peepAtaEl ||
          e.target === peepBraceEl
        ) {
          updatePeepHeightEstimate();
        }
        recalc();
      });
      root.addEventListener('change', recalc);
    }

    function syncStateFromDom() {
      var pa = root.querySelector('[data-stc-align][aria-pressed="true"]');
      if (pa) align = pa.getAttribute('data-stc-align') || 'center';
      var ptb = root.querySelector('[data-stc-tip][aria-pressed="true"]');
      if (ptb) tip = ptb.getAttribute('data-stc-tip') === 'fixed' ? 'fixed' : 'field';
      var pta = root.querySelector('[data-stc-tick-align][aria-pressed="true"]');
      if (pta) tickAlign = pta.getAttribute('data-stc-tick-align') || 'center';
      var psta = root.querySelector('[data-stc-sub-tick-align][aria-pressed="true"]');
      if (psta) subTickAlign = psta.getAttribute('data-stc-sub-tick-align') || 'center';
      var pls = root.querySelector('[data-stc-label-step][aria-pressed="true"]');
      if (pls) {
        var plsn = parseInt(pls.getAttribute('data-stc-label-step'), 10);
        labelStep = plsn === 5 ? 5 : 10;
      }
      var psl = root.querySelector('[data-stc-split-labels][aria-pressed="true"]');
      if (psl) splitLabels = psl.getAttribute('data-stc-split-labels') === 'on';
      syncSplitLabelControls();
      var pt = root.querySelector('[data-stc-tick-step][aria-pressed="true"]');
      if (pt) {
        var s = parseInt(pt.getAttribute('data-stc-tick-step'), 10);
        if (s === 1 || s === 2) tickStep = s;
      }
      syncSubTickAlignControls();
      if (labelOffsetEl) {
        var lo = parseInt(labelOffsetEl.value, 10);
        if (isFinite(lo)) labelOffsetPx = clamp(lo, LABEL_OFFSET_MIN, LABEL_OFFSET_MAX);
      }
      if (labelSizeEl) {
        var lsp = parseInt(labelSizeEl.value, 10);
        if (isFinite(lsp)) labelSizePct = clamp(lsp, LABEL_SIZE_PCT_MIN, LABEL_SIZE_PCT_MAX);
      }
      if (tickWidthEl) {
        var twp = parseInt(tickWidthEl.value, 10);
        if (isFinite(twp)) tickWidthPct = resolveTickWidthPct(twp);
      }
      if (tapeWidthEl && printWidthEl) syncTapeWidthFromNum();
      var ptc = root.querySelector('[data-stc-tape-count][aria-pressed="true"]');
      if (ptc) {
        var ptcn = parseInt(ptc.getAttribute('data-stc-tape-count'), 10);
        if (isFinite(ptcn)) tapeCount = ptcn;
      }
      var ptm = root.querySelector('[data-stc-tape-mode][aria-pressed="true"]');
      if (ptm) tapeMode = ptm.getAttribute('data-stc-tape-mode') || 'offset';
      var pftc = root.querySelector('[data-stc-five-tick-color][aria-pressed="true"]');
      if (pftc) fiveTickColorOn = pftc.getAttribute('data-stc-five-tick-color') === 'on';
      syncFiveTickColorUi();
      var pflc = root.querySelector('[data-stc-five-label-color][aria-pressed="true"]');
      if (pflc) fiveLabelColorOn = pflc.getAttribute('data-stc-five-label-color') === 'on';
      syncFiveLabelColorUi();
      var pp = root.querySelector('[data-stc-print-paper][aria-pressed="true"]:not([disabled])');
      if (pp) printPaper = pp.getAttribute('data-stc-print-paper') === 'label' ? 'label' : 'portrait';
      applyPrintClasses(printPaper);
    }

    function requirePrintAccess() {
      var Lib = window.TitleXSightTapeLibrary;
      if (root.getAttribute('data-stc-stale-session') === '1') {
        if (Lib) Lib.tryRestoreSession(root);
        return false;
      }
      if (!Lib || Lib.canPrint(root)) return true;
      Lib.stashPendingSnapshot(root);
      Lib.redirectToAccount(root, false);
      return false;
    }

    function updatePrintGateUi() {
      var Lib = window.TitleXSightTapeLibrary;
      var gateEl = root.querySelector('[data-stc-account-gate]');
      var reauthEl = root.querySelector('[data-stc-reauth-gate]');
      var libraryEl = root.querySelector('[data-stc-library]');
      var tapeCountWrap = root.querySelector('[data-stc-tape-count-wrap]');
      var tapeCountGuest = root.querySelector('[data-stc-tape-count-guest]');
      var cfg = Lib ? Lib.accountConfig(root) : { accountsEnabled: false, loggedIn: true };
      var staleSession = root.getAttribute('data-stc-stale-session') === '1';
      var needsAccount = cfg.accountsEnabled && !cfg.loggedIn;
      var authPending =
        root.getAttribute('data-stc-accounts-enabled') === '1' &&
        root.getAttribute('data-stc-auth-ready') !== '1';
      if (reauthEl) reauthEl.hidden = !staleSession;
      if (gateEl) gateEl.hidden = !needsAccount || staleSession;
      if (libraryEl) libraryEl.hidden = needsAccount;
      if (tapeCountWrap) tapeCountWrap.hidden = needsAccount;
      if (tapeCountGuest) tapeCountGuest.hidden = !needsAccount || staleSession;
      if (printLoadingBtn) {
        printLoadingBtn.hidden = !authPending;
        printLoadingBtn.setAttribute('aria-busy', authPending ? 'true' : 'false');
      }
      if (signInPrint) signInPrint.hidden = authPending || !needsAccount || staleSession;
      if (printBtn) printBtn.hidden = authPending;
      if (previewLayoutBtn) previewLayoutBtn.hidden = authPending;
      if (doPrintBtn) {
        doPrintBtn.textContent = staleSession ? 'Restore session' : needsAccount ? 'Sign in to print' : 'Print';
      }
    }

    function renderLibraryUi() {
      var Lib = window.TitleXSightTapeLibrary;
      var customerId = root.getAttribute('data-stc-customer-id');
      var profilesEl = root.querySelector('[data-stc-lib-profiles]');
      var versionEl = root.querySelector('[data-stc-lib-version]');
      var noteEl = root.querySelector('[data-stc-lib-note]');
      if (!Lib || !customerId || !profilesEl || !versionEl) return;
      var lib = Lib.loadLibrary(customerId);
      if (!lib) return;
      var active = Lib.activeProfile(lib);
      profilesEl.innerHTML = '';
      lib.profiles.forEach(function (profile) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = profile.name;
        btn.setAttribute('aria-pressed', profile.id === lib.activeProfileId ? 'true' : 'false');
        btn.setAttribute('data-stc-lib-profile', profile.id);
        profilesEl.appendChild(btn);
      });
      versionEl.innerHTML = '';
      if (!active || !active.history.length) {
        var emptyOpt = document.createElement('option');
        emptyOpt.value = '';
        emptyOpt.textContent = active && active.snapshot ? 'Current (no older versions yet)' : 'Save a setup to start version history';
        versionEl.appendChild(emptyOpt);
        versionEl.disabled = true;
      } else {
        var currentOpt = document.createElement('option');
        currentOpt.value = '';
        currentOpt.textContent = 'Current saved setup';
        versionEl.appendChild(currentOpt);
        active.history.forEach(function (entry, index) {
          var opt = document.createElement('option');
          opt.value = entry.id;
          opt.textContent = Lib.formatVersionLabel(entry, index);
          versionEl.appendChild(opt);
        });
        versionEl.disabled = false;
      }
      if (noteEl && active) {
        var when = active.updatedAt
          ? new Date(active.updatedAt).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
          : 'not saved yet';
        noteEl.textContent =
          active.name +
          ' · last saved ' +
          when +
          (active.history.length ? ' · ' + active.history.length + ' older version(s)' : '');
      }
    }

    function wireLibrary() {
      var Lib = window.TitleXSightTapeLibrary;
      var customerId = root.getAttribute('data-stc-customer-id');
      if (!Lib || !customerId) return;

      var fromShare = Lib.applyShareFromUrl(root);
      if (fromShare) {
        syncStateFromDom();
        root.setAttribute('data-stc-share-loaded', '1');
        if (gapNote) {
          gapNote.textContent = 'Loaded setup from printed QR / link.';
          gapNote.classList.remove('is-warn');
        }
        recalc();
      } else if (Lib.tryPendingSnapshot(root)) {
        syncStateFromDom();
        recalc();
      }

      var lib = Lib.loadLibrary(customerId);
      var active = Lib.activeProfile(lib);
      if (
        !fromShare &&
        active &&
        active.snapshot &&
        !root.getAttribute('data-stc-library-loaded')
      ) {
        Lib.applySnapshot(root, active.snapshot);
        syncStateFromDom();
        root.setAttribute('data-stc-library-loaded', '1');
      }

      renderLibraryUi();

      if (root.getAttribute('data-stc-library-wired')) return;
      root.setAttribute('data-stc-library-wired', '1');

      var newBtn = root.querySelector('[data-stc-lib-new]');
      var renameBtn = root.querySelector('[data-stc-lib-rename]');
      var saveBtn = root.querySelector('[data-stc-lib-save]');
      var profilesEl = root.querySelector('[data-stc-lib-profiles]');
      var versionEl = root.querySelector('[data-stc-lib-version]');

      if (profilesEl) {
        profilesEl.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-stc-lib-profile]');
          if (!btn) return;
          var id = btn.getAttribute('data-stc-lib-profile');
          Lib.saveCurrent(customerId, root);
          Lib.setActiveProfile(customerId, id);
          var profile = Lib.getProfile(Lib.loadLibrary(customerId), id);
          if (profile && profile.snapshot) {
            Lib.applySnapshot(root, profile.snapshot);
            syncStateFromDom();
            recalc();
          } else {
            recalc();
          }
          renderLibraryUi();
        });
      }

      if (saveBtn) {
        saveBtn.addEventListener('click', function () {
          Lib.saveCurrent(customerId, root);
          renderLibraryUi();
          var note = root.querySelector('[data-stc-lib-note]');
          if (note) note.textContent = 'Setup saved — older version kept in history.';
        });
      }

      if (newBtn) {
        newBtn.addEventListener('click', function () {
          var name = window.prompt('Name this bow setup', 'New bow');
          if (name == null) return;
          Lib.saveCurrent(customerId, root);
          var profile = Lib.createProfile(customerId, name);
          if (profile) {
            renderLibraryUi();
            recalc();
          }
        });
      }

      if (renameBtn) {
        renameBtn.addEventListener('click', function () {
          var libNow = Lib.loadLibrary(customerId);
          var activeNow = Lib.activeProfile(libNow);
          if (!activeNow) return;
          var name = window.prompt('Rename bow setup', activeNow.name);
          if (name == null || !String(name).trim()) return;
          Lib.renameProfile(customerId, activeNow.id, name);
          renderLibraryUi();
        });
      }

      if (versionEl) {
        versionEl.addEventListener('change', function () {
          var versionId = versionEl.value;
          if (!versionId) return;
          var libNow = Lib.loadLibrary(customerId);
          var activeNow = Lib.activeProfile(libNow);
          if (!activeNow) return;
          if (!window.confirm('Restore this version? Your current setup will be saved to history first.')) {
            versionEl.value = '';
            return;
          }
          var snapshot = Lib.restoreVersion(customerId, activeNow.id, versionId);
          if (snapshot) {
            Lib.applySnapshot(root, snapshot);
            syncStateFromDom();
            recalc();
            renderLibraryUi();
          }
        });
      }

      document.addEventListener('stc-library-changed', renderLibraryUi);
    }

    document.addEventListener('tx-calc-presets-changed', function () {
      if (presets && !presets.hasUrlOverride('fps')) presets.apply('sight-tape', root);
      syncStateFromDom();
      recalc();
    });

    alignBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setAlign(btn.getAttribute('data-stc-align') || 'center');
      });
    });

    tipBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTip(btn.getAttribute('data-stc-tip') || 'field');
      });
    });

    tickAlignBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTickAlign(btn.getAttribute('data-stc-tick-align') || 'center');
      });
    });

    subTickAlignBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSubTickAlign(btn.getAttribute('data-stc-sub-tick-align') || 'center');
      });
    });

    labelStepBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-stc-label-step'), 10);
        if (isFinite(step)) setLabelStep(step);
      });
    });

    splitLabelBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSplitLabels(btn.getAttribute('data-stc-split-labels') === 'on');
      });
    });

    tickBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-stc-tick-step'), 10);
        if (step === 1 || step === 2) setTickStep(step);
      });
    });

    fiveTickColorBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setFiveTickColor(btn.getAttribute('data-stc-five-tick-color') === 'on' ? 'on' : 'off');
      });
    });
    syncFiveTickColorUi();

    fiveLabelColorBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setFiveLabelColor(btn.getAttribute('data-stc-five-label-color') === 'on' ? 'on' : 'off');
      });
    });
    syncFiveLabelColorUi();

    sightUnitsBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSightUnits(btn.getAttribute('data-stc-sight-units'));
      });
    });

    function setPrintPaper(next) {
      printPaper = next === 'label' ? 'label' : 'portrait';
      printPaperBtns.forEach(function (btn) {
        btn.setAttribute(
          'aria-pressed',
          btn.getAttribute('data-stc-print-paper') === printPaper ? 'true' : 'false'
        );
      });
      applyPrintClasses(printPaper);
      recalc();
    }

    tapeCountBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = parseInt(btn.getAttribute('data-stc-tape-count'), 10);
        if (isFinite(n)) setTapeCount(n);
      });
    });

    tapeModeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTapeMode(btn.getAttribute('data-stc-tape-mode') || 'offset');
      });
    });

    applyPrintClasses(printPaper);

    printPaperBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        setPrintPaper(btn.getAttribute('data-stc-print-paper') || 'portrait');
      });
    });

    if (signInPrint) {
      signInPrint.addEventListener('click', function () {
        var Lib = window.TitleXSightTapeLibrary;
        if (Lib) Lib.stashPendingSnapshot(root);
      });
    }

    if (printBtn && printPreview) {
      printBtn.addEventListener('click', function () {
        recalc();
        var Lib = window.TitleXSightTapeLibrary;
        var customerId = root.getAttribute('data-stc-customer-id');
        if (Lib && customerId) Lib.saveCurrent(customerId, root, { versionLabel: 'Before print' });
        renderLibraryUi();
        applyPrintClasses(printPaper);
        openPrintPreviewModal();
      });
    }
    if (previewLayoutBtn && printPreview) {
      previewLayoutBtn.addEventListener('click', function () {
        openPrintPreviewModal();
      });
    }
    if (closePreviewBtn && printPreview) {
      closePreviewBtn.addEventListener('click', function () {
        closePrintPreviewModal();
      });
    }
    if (doPrintBtn) {
      doPrintBtn.addEventListener('click', function () {
        if (!requirePrintAccess()) return;
        applyPrintClasses(printPaper);
        runPrint(printPreview, printPreviewAnchor, root, recalc);
      });
    }

    var restoreBtn = root.querySelector('[data-stc-restore-session]');
    var forgetBtn = root.querySelector('[data-stc-forget-session]');
    if (restoreBtn) {
      restoreBtn.addEventListener('click', function () {
        var Lib = window.TitleXSightTapeLibrary;
        if (Lib) Lib.tryRestoreSession(root);
      });
    }
    if (forgetBtn) {
      forgetBtn.addEventListener('click', function () {
        var Lib = window.TitleXSightTapeLibrary;
        if (Lib) {
          Lib.clearCustomerCookie();
          root.removeAttribute('data-stc-stale-session');
          root.removeAttribute('data-stc-auth-optimistic');
          root.setAttribute('data-stc-logged-in', '0');
          root.removeAttribute('data-stc-customer-id');
          root.removeAttribute('data-stc-customer-email');
          var wrapEl = root.querySelector('[data-stc-reauth-email-wrap]');
          if (wrapEl) wrapEl.hidden = true;
          finishAccountInit();
        }
      });
    }

    root.addEventListener('stc-auth-refreshed', finishAccountInit);

    function wireAuthLinks() {
      var tools = window.TitleXCalcTools;
      var loginUrl =
        root.getAttribute('data-stc-auth-login-url') ||
        (tools && tools.buildLoginUrl ? tools.buildLoginUrl(root) : '');
      if (!loginUrl) return;
      root.querySelectorAll('[data-stc-auth-login], [data-stc-sign-in-print]').forEach(function (link) {
        link.href = loginUrl;
      });
    }

    function finishAccountInit() {
      root.setAttribute('data-stc-auth-ready', '1');
      wireAuthLinks();
      updatePrintGateUi();
      var LibBoot = window.TitleXSightTapeLibrary;
      if (LibBoot && LibBoot.applyShareFromUrl && !root.getAttribute('data-stc-share-loaded')) {
        if (LibBoot.applyShareFromUrl(root)) {
          syncStateFromDom();
          root.setAttribute('data-stc-share-loaded', '1');
          if (gapNote) {
            gapNote.textContent = 'Loaded setup from printed QR / link.';
            gapNote.classList.remove('is-warn');
          }
        }
      }
      wireLibrary();
      syncSubTickAlignControls();
      syncSplitLabelControls();
      recalc();
    }

    function beginAccountInit() {
      var LibBoot = window.TitleXSightTapeLibrary;
      if (!LibBoot || root.getAttribute('data-stc-accounts-enabled') !== '1') {
        root.setAttribute('data-stc-auth-ready', '1');
        finishAccountInit();
        return;
      }
      LibBoot.syncCookieFromRoot(root);
      if (LibBoot.applyOptimisticAuthFromCookie(root)) finishAccountInit();
      LibBoot.refreshAuthState(root).then(function (result) {
        if (result && result.staleCookie && LibBoot.maybeAutoRestoreSession(root, result)) return;
        finishAccountInit();
      });
    }

    beginAccountInit();
    updatePrintGateUi();
  }

  function boot() {
    document.querySelectorAll('[data-stc-calc]').forEach(init);
  }

  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    document.querySelectorAll('[data-stc-calc][data-stc-ready]').forEach(function (el) {
      var Lib = window.TitleXSightTapeLibrary;
      if (!Lib || !Lib.refreshAuthState) return;
      Lib.refreshAuthState(el).then(function () {
        el.dispatchEvent(new CustomEvent('stc-auth-refreshed'));
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
